var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../owlbert-plugins/packages/workspace-modules/dist/license_feature_ids.js
var require_license_feature_ids = __commonJS({
  "../owlbert-plugins/packages/workspace-modules/dist/license_feature_ids.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OWLBERT_PRO_FEATURE_ID = exports.PLUGIN_FEATURES_ALL = exports.PLUGIN_FEATURE_WILDCARD = exports.PLUGIN_FEATURE_ID_PREFIX = void 0;
    exports.normalizeLicenseFeatureIdForLookup = normalizeLicenseFeatureIdForLookup2;
    exports.licenseFeatureListIncludes = licenseFeatureListIncludes2;
    exports.isOwlbertProFromLicenseFeatureIds = isOwlbertProFromLicenseFeatureIds2;
    exports.PLUGIN_FEATURE_ID_PREFIX = "plugin:";
    exports.PLUGIN_FEATURE_WILDCARD = "plugin:*";
    exports.PLUGIN_FEATURES_ALL = "plugins:all";
    var PLUGIN_ALL_PLUGINS_GRANT_IDS = /* @__PURE__ */ new Set([
      exports.PLUGIN_FEATURES_ALL,
      "plugins_all",
      "plugin:all",
      "plugin_all"
    ]);
    function grantedIncludesAllPluginsOnly(grantedExpanded) {
      for (const id of PLUGIN_ALL_PLUGINS_GRANT_IDS) {
        if (grantedExpanded.has(id))
          return true;
      }
      return false;
    }
    function isPluginLicenseFeatureId(featureId) {
      const t = featureId.trim();
      return t.startsWith(exports.PLUGIN_FEATURE_ID_PREFIX) && t.length > exports.PLUGIN_FEATURE_ID_PREFIX.length;
    }
    exports.OWLBERT_PRO_FEATURE_ID = "owlbert:pro";
    function normalizeLicenseFeatureIdForLookup2(id) {
      const t = id.trim();
      if (!t)
        return [];
      const a = t.replace(/-/g, "_");
      const b = t.replace(/_/g, "-");
      return [.../* @__PURE__ */ new Set([t, a, b])];
    }
    function licenseFeatureListIncludes2(granted, featureId) {
      if (!featureId?.trim())
        return true;
      const grantedExpanded = /* @__PURE__ */ new Set();
      for (const g of granted) {
        for (const v of normalizeLicenseFeatureIdForLookup2(g)) {
          grantedExpanded.add(v);
        }
      }
      if (grantedExpanded.has(exports.PLUGIN_FEATURE_WILDCARD))
        return true;
      if (grantedIncludesAllPluginsOnly(grantedExpanded) && isPluginLicenseFeatureId(featureId)) {
        return true;
      }
      for (const key of normalizeLicenseFeatureIdForLookup2(featureId)) {
        if (grantedExpanded.has(key))
          return true;
      }
      return false;
    }
    function isOwlbertProFromLicenseFeatureIds2(features) {
      if (!features?.length)
        return false;
      return licenseFeatureListIncludes2(features, exports.OWLBERT_PRO_FEATURE_ID);
    }
  }
});

// ../owlbert-plugins/packages/workspace-modules/dist/workspace_modules_catalog.js
var require_workspace_modules_catalog = __commonJS({
  "../owlbert-plugins/packages/workspace-modules/dist/workspace_modules_catalog.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.KNOWN_PLUGIN_LICENSE_FEATURE_IDS = exports.KNOWN_PLUGIN_FALLBACKS = exports.DEFAULT_ENABLED_MODULE_NAMES = exports.CORE_MODULE_NAME = void 0;
    exports.normalizeOwlbertModuleKey = normalizeOwlbertModuleKey2;
    exports.ensureCoreInList = ensureCoreInList2;
    exports.normalizePluginLicenseSlugFromModuleName = normalizePluginLicenseSlugFromModuleName2;
    exports.derivePluginLicenseFeatureIdForModule = derivePluginLicenseFeatureIdForModule2;
    exports.resolveCanonicalHostedWebModuleName = resolveCanonicalHostedWebModuleName2;
    exports.listHostedWebModuleSettingsRows = listHostedWebModuleSettingsRows2;
    exports.listHostedWebNavModules = listHostedWebNavModules2;
    exports.coerceEnabledModulesForHosted = coerceEnabledModulesForHosted2;
    exports.validateEnabledModulesForHosted = validateEnabledModulesForHosted2;
    var license_feature_ids_js_1 = require_license_feature_ids();
    exports.CORE_MODULE_NAME = "core";
    exports.DEFAULT_ENABLED_MODULE_NAMES = [exports.CORE_MODULE_NAME];
    function normalizeOwlbertModuleKey2(name) {
      return name.toLowerCase().replace(/[\s_-]+/g, "");
    }
    function ensureCoreInList2(list) {
      if (list.some((m) => normalizeOwlbertModuleKey2(m) === normalizeOwlbertModuleKey2(exports.CORE_MODULE_NAME)))
        return list;
      return [exports.CORE_MODULE_NAME, ...list];
    }
    exports.KNOWN_PLUGIN_FALLBACKS = [
      {
        name: "meal_planning",
        displayName: "Meal Planning",
        description: "Plan meals and manage recipes. Create meal plans and assign recipes to days. Use the Recipe Manager to add recipes from your knowledgebase; use the Meal Planner to build plans by answering a few questions.",
        version: "0.1.0"
      },
      { name: "worldbuilder", displayName: "World Builder", description: "Build and explore worlds.", version: "0.1.0" },
      {
        name: "story_writer",
        displayName: "Story Writer",
        description: "Write and manage stories, story arcs, and interactive stories.",
        version: "0.1.0"
      },
      { name: "github", displayName: "GitHub", description: "GitHub integration.", version: "0.1.0" },
      { name: "rpg_campaign", displayName: "RPG Campaign", description: "Manage tabletop RPG campaigns.", version: "0.1.0" },
      { name: "dashboard", displayName: "Dashboard", description: "Dashboard and overview.", version: "0.1.0" },
      {
        name: "research_assistant",
        displayName: "Research Assistant",
        description: "Research and citation assistant.",
        version: "0.1.0"
      },
      { name: "blog", displayName: "Blog", description: "Blog management.", version: "0.1.0" },
      { name: "marketdata", displayName: "Market Data", description: "Market data and charts.", version: "0.1.0" },
      {
        name: "slack",
        displayName: "Slack",
        description: "Scan Slack for messages and threads that need your response.",
        version: "0.1.0"
      }
    ];
    exports.KNOWN_PLUGIN_LICENSE_FEATURE_IDS = {
      meal_planning: "plugin:meal-planning",
      worldbuilder: "plugin:worldbuilder",
      story_writer: "plugin:storywriter",
      github: "plugin:github",
      rpg_campaign: "plugin:rpg-campaign",
      dashboard: "plugin:dashboard",
      research_assistant: "plugin:research-assistant",
      blog: "plugin:blog",
      marketdata: "plugin:marketdata",
      slack: "plugin:slack"
    };
    var CANONICAL_FALLBACK_BY_KEY = /* @__PURE__ */ new Map();
    for (const fb of exports.KNOWN_PLUGIN_FALLBACKS) {
      CANONICAL_FALLBACK_BY_KEY.set(normalizeOwlbertModuleKey2(fb.name), fb.name);
    }
    var ALLOWED_HOSTED_MODULE_NAMES = /* @__PURE__ */ new Set([
      exports.CORE_MODULE_NAME,
      ...exports.KNOWN_PLUGIN_FALLBACKS.map((f) => f.name)
    ]);
    function normalizePluginLicenseSlugFromModuleName2(name) {
      return name.toLowerCase().replace(/[\s_-]+/g, "-").replace(/^-|-$/g, "");
    }
    function derivePluginLicenseFeatureIdForModule2(moduleCanonicalName) {
      const known = exports.KNOWN_PLUGIN_LICENSE_FEATURE_IDS[moduleCanonicalName];
      if (known)
        return known;
      return `${license_feature_ids_js_1.PLUGIN_FEATURE_ID_PREFIX}${normalizePluginLicenseSlugFromModuleName2(moduleCanonicalName)}`;
    }
    function resolveCanonicalHostedWebModuleName2(raw) {
      const key = normalizeOwlbertModuleKey2(raw);
      if (key === normalizeOwlbertModuleKey2(exports.CORE_MODULE_NAME))
        return exports.CORE_MODULE_NAME;
      return CANONICAL_FALLBACK_BY_KEY.get(key) ?? null;
    }
    function listHostedWebModuleSettingsRows2() {
      const core = {
        canonicalName: exports.CORE_MODULE_NAME,
        displayName: "Core",
        description: "Base Owlbert experience. Always on for this workspace.",
        isCore: true,
        licenseFeatureId: ""
      };
      const plugins = exports.KNOWN_PLUGIN_FALLBACKS.map((fb) => ({
        canonicalName: fb.name,
        displayName: fb.displayName,
        description: fb.description,
        isCore: false,
        licenseFeatureId: derivePluginLicenseFeatureIdForModule2(fb.name)
      }));
      return [core, ...plugins];
    }
    function listHostedWebNavModules2(enabledModules) {
      const keySet = new Set(enabledModules.map((m) => normalizeOwlbertModuleKey2(m)));
      return listHostedWebModuleSettingsRows2().filter((r) => !r.isCore && keySet.has(normalizeOwlbertModuleKey2(r.canonicalName))).map((r) => ({
        canonicalName: r.canonicalName,
        displayName: r.displayName,
        description: r.description
      }));
    }
    function normalizeCoreInList(list) {
      return ensureCoreInList2(list).map((m) => normalizeOwlbertModuleKey2(m) === normalizeOwlbertModuleKey2(exports.CORE_MODULE_NAME) ? exports.CORE_MODULE_NAME : m);
    }
    function coerceEnabledModulesForHosted2(stored, entitlementFeatures) {
      const ordered = [];
      const seen = /* @__PURE__ */ new Set();
      for (const raw of stored) {
        const t = typeof raw === "string" ? raw.trim() : "";
        if (!t)
          continue;
        const canon = resolveCanonicalHostedWebModuleName2(t);
        if (!canon)
          continue;
        const k = normalizeOwlbertModuleKey2(canon);
        if (seen.has(k))
          continue;
        seen.add(k);
        ordered.push(canon);
      }
      const withCore = normalizeCoreInList(ordered);
      const out = [];
      for (const name of withCore) {
        if (name === exports.CORE_MODULE_NAME) {
          if (!out.includes(exports.CORE_MODULE_NAME))
            out.push(exports.CORE_MODULE_NAME);
          continue;
        }
        if (!ALLOWED_HOSTED_MODULE_NAMES.has(name))
          continue;
        const fid = derivePluginLicenseFeatureIdForModule2(name);
        if (!(0, license_feature_ids_js_1.licenseFeatureListIncludes)(entitlementFeatures, fid))
          continue;
        out.push(name);
      }
      return out.length ? out : [exports.CORE_MODULE_NAME];
    }
    function validateEnabledModulesForHosted2(requested, entitlementFeatures) {
      const ordered = [];
      const seen = /* @__PURE__ */ new Set();
      for (const raw of requested) {
        const t = typeof raw === "string" ? raw.trim() : "";
        if (!t)
          continue;
        const canon = resolveCanonicalHostedWebModuleName2(t);
        if (!canon)
          return { ok: false, message: `Unknown module: ${t}` };
        const k = normalizeOwlbertModuleKey2(canon);
        if (seen.has(k))
          continue;
        seen.add(k);
        ordered.push(canon);
      }
      const withCore = normalizeCoreInList(ordered);
      const out = [];
      for (const name of withCore) {
        if (name === exports.CORE_MODULE_NAME) {
          if (!out.includes(exports.CORE_MODULE_NAME))
            out.push(exports.CORE_MODULE_NAME);
          continue;
        }
        if (!ALLOWED_HOSTED_MODULE_NAMES.has(name))
          return { ok: false, message: `Unknown module: ${name}` };
        const fid = derivePluginLicenseFeatureIdForModule2(name);
        if (!(0, license_feature_ids_js_1.licenseFeatureListIncludes)(entitlementFeatures, fid)) {
          return { ok: false, message: `Not licensed for module: ${name}` };
        }
        out.push(name);
      }
      return { ok: true, enabled_modules: out };
    }
  }
});

// ../owlbert-plugins/packages/workspace-modules/dist/index.js
var require_dist = __commonJS({
  "../owlbert-plugins/packages/workspace-modules/dist/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    }));
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p)) __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require_license_feature_ids(), exports);
    __exportStar(require_workspace_modules_catalog(), exports);
  }
});

// src/hosted/url.ts
function isLikelyLocalDevHost(hostname) {
  const h = hostname.toLowerCase();
  if (h === "localhost" || h === "127.0.0.1" || h === "::1" || h === "[::1]") return true;
  if (h.endsWith(".local")) return true;
  if (/^127\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  const m = /^172\.(\d{1,2})\.\d{1,3}\.\d{1,3}$/.exec(h);
  if (m) {
    const second = Number(m[1]);
    if (second >= 16 && second <= 31) return true;
  }
  return false;
}
function hostnameForSchemeGuess(raw) {
  const s = raw.trim();
  if (!s) return null;
  try {
    if (/^https?:\/\//i.test(s)) return new URL(s).hostname;
    if (s.startsWith("//")) return new URL(`http:${s}`).hostname;
    return new URL(`http://${s}`).hostname;
  } catch {
    const hostPort = s.split("/")[0] ?? s;
    const host = hostPort.split(":")[0] ?? hostPort;
    return host || null;
  }
}
function ensureAbsoluteUrlWithScheme(input) {
  const s = input.trim();
  if (!s) return s;
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith("//")) {
    const host2 = hostnameForSchemeGuess(s);
    const scheme2 = host2 && isLikelyLocalDevHost(host2) ? "http" : "https";
    return `${scheme2}:${s}`;
  }
  const host = hostnameForSchemeGuess(s);
  const scheme = host && isLikelyLocalDevHost(host) ? "http" : "https";
  return `${scheme}://${s}`;
}
function coerceLocalDevHttpsToHttp(url) {
  try {
    const u = new URL(url);
    if (u.protocol === "https:" && isLikelyLocalDevHost(u.hostname)) {
      u.protocol = "http:";
      return u.href.replace(/\/$/, "");
    }
  } catch {
  }
  return url;
}
function normalizeHostedBackendBaseUrl(input) {
  let s = coerceLocalDevHttpsToHttp(ensureAbsoluteUrlWithScheme(input));
  s = s.replace(/\/+$/, "");
  const lower = s.toLowerCase();
  if (lower.endsWith("/trpc")) {
    s = s.slice(0, -"/trpc".length);
    s = s.replace(/\/+$/, "");
  }
  return s;
}
function buildHostedTrpcUrl(baseUrl, trpcPath = "/trpc") {
  const base = normalizeHostedBackendBaseUrl(baseUrl);
  const path = trpcPath.startsWith("/") ? trpcPath : `/${trpcPath}`;
  return `${base}${path}`;
}

// src/hosted/browser_session_store.ts
var defaultStorageKey = "owlbert_web_session_v1";
var MemoryOnlySessionStore = class {
  access_token = null;
  refresh_token = null;
  getSession() {
    if (!this.access_token) return null;
    return {
      access_token: this.access_token,
      refresh_token: this.refresh_token ?? void 0
    };
  }
  setSession(access_token, refresh_token) {
    this.access_token = access_token;
    this.refresh_token = refresh_token ?? null;
  }
  clearSession() {
    this.access_token = null;
    this.refresh_token = null;
  }
};
function createLocalStorageOwlbertSessionStore(options) {
  const storageKey = options?.storageKey ?? defaultStorageKey;
  if (typeof window === "undefined") {
    return new MemoryOnlySessionStore();
  }
  const memoryFallback = new MemoryOnlySessionStore();
  function readStorage() {
    try {
      return window.localStorage.getItem(storageKey);
    } catch {
      return null;
    }
  }
  return {
    getSession() {
      const raw = readStorage();
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          if (parsed.access_token) {
            return {
              access_token: parsed.access_token,
              refresh_token: parsed.refresh_token ?? void 0
            };
          }
        } catch {
        }
      }
      return memoryFallback.getSession();
    },
    setSession(access_token, refresh_token) {
      memoryFallback.setSession(access_token, refresh_token);
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({ access_token, refresh_token: refresh_token ?? null }));
      } catch {
      }
    },
    clearSession() {
      memoryFallback.clearSession();
      try {
        window.localStorage.removeItem(storageKey);
      } catch {
      }
    }
  };
}

// src/hosted/browser_session_client.ts
import * as OwlbertTrpc from "@owlbert-backend/trpc-client";
function createBrowserHostedSessionClient(options) {
  const url = buildHostedTrpcUrl(options.baseUrl, options.trpcPath ?? "/trpc");
  return OwlbertTrpc.createOwlbertClientWithSession({
    url,
    sessionStore: options.sessionStore,
    headers: options.headers
  });
}

// src/hosted/client.ts
import * as OwlbertTrpc2 from "@owlbert-backend/trpc-client";
function resolveCreateOwlbertClient() {
  const mod = OwlbertTrpc2;
  if (typeof mod.createOwlbertClient === "function") return mod.createOwlbertClient;
  if (typeof mod.default === "function") return mod.default;
  throw new Error(
    "@owlbert-backend/trpc-client: missing createOwlbertClient (named or default). Rebuild: pnpm -C packages/trpc-client run build (from owlbert-backend)."
  );
}
function createHostedOwlbertClient(options) {
  const { baseUrl, trpcPath = "/trpc", tokenProvider, headers } = options;
  const url = buildHostedTrpcUrl(baseUrl, trpcPath);
  return resolveCreateOwlbertClient()({
    url,
    token: {
      getToken: () => tokenProvider.getAccessToken()
    },
    headers
  });
}

// src/hosted/user_documents.ts
var HOSTED_USER_DOCUMENTS_PROCEDURE_KEYS = [
  "list",
  "get",
  "add",
  "update",
  "addSourceLocation",
  "delete"
];
function isHostedUserDocumentTrashed(metadata) {
  const deletedAt = metadata?.deletedAt;
  return typeof deletedAt === "string" && deletedAt.length > 0;
}
function partitionHostedUserDocumentsByTrash(rows) {
  const active = [];
  const trashed = [];
  for (const r of rows) {
    if (isHostedUserDocumentTrashed(r.metadata)) trashed.push(r);
    else active.push(r);
  }
  return { active, trashed };
}
function sortHostedUserDocumentsByDeletedAtDesc(rows) {
  return [...rows].sort((a, b) => {
    const da = typeof a.metadata?.deletedAt === "string" ? a.metadata.deletedAt : "";
    const db = typeof b.metadata?.deletedAt === "string" ? b.metadata.deletedAt : "";
    return db.localeCompare(da);
  });
}
async function hostedUserDocumentsList(procedures, workspaceId) {
  const rows = await procedures.list.query({ workspaceId });
  return rows;
}
async function hostedUserDocumentsGet(procedures, workspaceId, id) {
  const row = await procedures.get.query({ workspaceId, id });
  if (!row) return null;
  return row;
}
async function hostedUserDocumentsAdd(procedures, input) {
  return await procedures.add.mutate(input);
}
async function hostedUserDocumentsUpdate(procedures, input) {
  await procedures.update.mutate(input);
}
async function hostedUserDocumentsAddSourceLocation(procedures, input) {
  await procedures.addSourceLocation.mutate(input);
}
async function hostedUserDocumentsDelete(procedures, input) {
  await procedures.delete.mutate(input);
}

// src/hosted/assistants.ts
var HOSTED_ASSISTANTS_PROCEDURE_KEYS = ["list", "create", "update", "delete"];
async function hostedAssistantsList(procedures, input) {
  return procedures.list.query(input);
}
async function hostedAssistantsCreate(procedures, input) {
  return procedures.create.mutate(input);
}
async function hostedAssistantsUpdate(procedures, input) {
  return procedures.update.mutate(input);
}
async function hostedAssistantsDelete(procedures, input) {
  await procedures.delete.mutate(input);
}

// src/hosted/chat_messages.ts
var HOSTED_CHAT_MESSAGES_PROCEDURE_KEYS = [
  "getForSession",
  "upsertMessage",
  "deleteForSession",
  "deleteMessage",
  "appendToMessage",
  "copyHistory"
];
async function hostedChatMessagesGetForSession(procedures, input) {
  return procedures.getForSession.query(input);
}
async function hostedChatMessagesUpsertMessage(procedures, input) {
  await procedures.upsertMessage.mutate(input);
}
async function hostedChatMessagesDeleteForSession(procedures, input) {
  await procedures.deleteForSession.mutate(input);
}
async function hostedChatMessagesDeleteMessage(procedures, input) {
  await procedures.deleteMessage.mutate(input);
}
async function hostedChatMessagesAppendToMessage(procedures, input) {
  await procedures.appendToMessage.mutate(input);
}
async function hostedChatMessagesCopyHistory(procedures, input) {
  await procedures.copyHistory.mutate(input);
}

// src/hosted/chat_session_metadata.ts
var HOSTED_CHAT_SESSION_METADATA_PROCEDURE_KEYS = [
  "getMetadataForWorkspace",
  "setDisplayName",
  "setBookmark",
  "upsertMetadata",
  "removeBookmark",
  "deleteSession"
];
async function hostedChatSessionMetadataGetForWorkspace(procedures, input) {
  return procedures.getMetadataForWorkspace.query(input);
}
async function hostedChatSessionMetadataSetDisplayName(procedures, input) {
  await procedures.setDisplayName.mutate(input);
}
async function hostedChatSessionMetadataSetBookmark(procedures, input) {
  await procedures.setBookmark.mutate(input);
}
async function hostedChatSessionMetadataUpsertMetadata(procedures, input) {
  await procedures.upsertMetadata.mutate(input);
}
async function hostedChatSessionMetadataRemoveBookmark(procedures, input) {
  await procedures.removeBookmark.mutate(input);
}
async function hostedChatSessionMetadataDeleteSession(procedures, input) {
  await procedures.deleteSession.mutate(input);
}

// src/hosted/library.ts
var HOSTED_LIBRARY_PROCEDURE_KEYS = ["get", "set"];
async function hostedLibraryGet(procedures, input) {
  return procedures.get.query(input);
}
async function hostedLibrarySet(procedures, input) {
  await procedures.set.mutate(input);
}

// src/hosted/page_state.ts
var HOSTED_PAGE_STATE_PROCEDURE_KEYS = ["getAll", "get", "set", "remove"];
async function hostedPageStateGetAll(procedures, input) {
  return procedures.getAll.query(input);
}
async function hostedPageStateGet(procedures, input) {
  return procedures.get.query(input);
}
async function hostedPageStateSet(procedures, input) {
  await procedures.set.mutate(input);
}
async function hostedPageStateRemove(procedures, input) {
  await procedures.remove.mutate(input);
}

// src/hosted/session_attachments.ts
var HOSTED_SESSION_ATTACHMENTS_PROCEDURE_KEYS = ["list", "getContent", "add", "remove", "markIncluded"];
async function hostedSessionAttachmentsList(procedures, input) {
  return procedures.list.query(input);
}
async function hostedSessionAttachmentsGetContent(procedures, input) {
  return procedures.getContent.query(input);
}
async function hostedSessionAttachmentsAdd(procedures, input) {
  return procedures.add.mutate(input);
}
async function hostedSessionAttachmentsRemove(procedures, input) {
  await procedures.remove.mutate(input);
}
async function hostedSessionAttachmentsMarkIncluded(procedures, input) {
  await procedures.markIncluded.mutate(input);
}

// src/hosted/knowledgebase_remote.ts
var REMOTE_KNOWLEDGEBASE_PROCEDURE_KEYS = [
  "search",
  "insert",
  "deleteBySourceId",
  "deleteBySourceIdAndDocumentId",
  "deleteByWorkspaceId",
  "getAllDocuments",
  "tableExists",
  "getEmbeddingDimensions"
];
async function remoteKnowledgebaseSearch(procedures, input) {
  return procedures.search.mutate(input);
}
async function remoteKnowledgebaseInsert(procedures, input) {
  await procedures.insert.mutate(input);
}
async function remoteKnowledgebaseDeleteBySourceId(procedures, input) {
  await procedures.deleteBySourceId.mutate(input);
}
async function remoteKnowledgebaseDeleteBySourceIdAndDocumentId(procedures, input) {
  await procedures.deleteBySourceIdAndDocumentId.mutate(input);
}
async function remoteKnowledgebaseDeleteByWorkspaceId(procedures, input) {
  await procedures.deleteByWorkspaceId.mutate(input);
}
async function remoteKnowledgebaseGetAllDocuments(procedures, input) {
  return procedures.getAllDocuments.query(input);
}
async function remoteKnowledgebaseTableExists(procedures) {
  return procedures.tableExists.query();
}
async function remoteKnowledgebaseGetEmbeddingDimensions(procedures) {
  return procedures.getEmbeddingDimensions.query();
}

// src/hosted/workspaces.ts
var HOSTED_WORKSPACES_PROCEDURE_KEYS = ["list", "create", "update", "delete"];
async function hostedWorkspacesList(procedures) {
  return procedures.list.query();
}
async function hostedWorkspacesCreate(procedures, input) {
  return procedures.create.mutate(input);
}
async function hostedWorkspacesUpdate(procedures, input) {
  return procedures.update.mutate(input);
}
async function hostedWorkspacesDelete(procedures, input) {
  await procedures.delete.mutate(input);
}

// src/orchestration/staged_tool_policy.ts
function shouldUseStagedToolPolicyForConfig(config, moduleId) {
  if (!config || config.toolsOnly) return false;
  if (config.skip_staged_tools === true) return false;
  if (moduleId != null && moduleId !== "core") return false;
  return true;
}
var STAGED_CHAT_TOOL_POLICY_PROMPT = `
<staged_tool_and_context_policy>
1. Start from the current user message (including images or extracted file text) and any <additional_context> blocks prepended to it.
2. Workspace knowledgebase (search_knowledgebase): For factual questions about anything that could live in the user's indexed material (uploaded files, notes, policies, runbooks, specs, tickets, design docs, research, code-adjacent docs, etc.), call search_knowledgebase before answering from general knowledge\u2014even if you think you already know the answer. General knowledge is not a substitute for checking what is actually in the workspace.
3. Search strategy: Use focused queries. If the first query returns nothing or only tangential snippets, that is not proof the material is absent\u2014try several different phrasings (synonyms, acronyms, product or project names, section headings, dates, error strings, API or config identifiers, people's names, table or schedule keywords\u2014whatever fits the domain). Prefer multiple narrow searches over one vague keyword when the user asks for several distinct facts.
4. If chunks reference a document but omit the exact detail the user needs, search again with terms aimed at that gap, or fetch the full indexed document using the documentId field from a search hit (not the display filename alone).
5. Honesty: Never claim you searched the knowledgebase unless you actually invoked search_knowledgebase in this turn or an immediately prior tool step for the same question.
6. If, after genuine attempts in 2\u20134, nothing relevant is returned, say explicitly that nothing useful was found in the workspace knowledgebase, then you may answer from general knowledge and label it as such.
7. Other capabilities (file writing, web search, MCP, assistant-specific tools not in your current tool list): call ask_for_permission with the appropriate toolId before first use. Do not assume tools you do not see are callable.
</staged_tool_and_context_policy>
`.trim();
var SEARCH_KNOWLEDGEBASE_NONSTAGED_HINT = `
<workspace_knowledgebase_usage>
You have search_knowledgebase: for factual questions about anything the user may have indexed or uploaded (notes, policies, specs, runbooks, tickets, PDFs, etc.), search before relying on general knowledge. If the first query misses, try alternate phrasings (synonyms, acronyms, headings, dates, identifiers). Use documentId when you have an id and need fuller text. Do not claim you searched without calling the tool.
</workspace_knowledgebase_usage>
`.trim();
function getSearchKnowledgebasePolicyAppendIfNeeded(tools) {
  if (!tools?.length) {
    return void 0;
  }
  const hasKb = tools.some((t) => t.id === "search_knowledgebase");
  if (!hasKb) {
    return void 0;
  }
  return SEARCH_KNOWLEDGEBASE_NONSTAGED_HINT;
}

// src/search/knowledgebase_ranking.ts
var KB_SEARCH_MIN_SIMILARITY_THRESHOLD = 0.2;
var KB_SEARCH_STRICT_SHORT_QUERY_MAX_WORDS = 1;
var KB_SEARCH_MIN_SIMILARITY_WITHOUT_CONTENT_MATCH = 0.55;
function getKnowledgebaseDocumentKey(id, metadata) {
  const original = metadata?.original_document_id;
  if (original) return original;
  const lastUnderscore = id.lastIndexOf("_");
  if (lastUnderscore > 0) {
    const suffix = id.slice(lastUnderscore + 1);
    if (/^\d+$/.test(suffix)) return id.slice(0, lastUnderscore);
  }
  return id;
}
function getKnowledgebaseContentMatchScore(query, content) {
  const q = query.toLowerCase().trim();
  const c = content.toLowerCase();
  if (!q || !c) return 0;
  if (c.includes(q)) return 3;
  const words = q.split(/\s+/).filter((w) => w.length > 0);
  const matching = words.filter((w) => c.includes(w));
  if (words.length === 0) return 0;
  return 1.5 * (matching.length / words.length);
}
function vectorDistanceToSimilarity(distance) {
  return Math.max(0, 1 - distance / 2);
}
function getKnowledgebaseNameMatchScore(query, name) {
  const queryLower = query.toLowerCase().trim();
  const nameLower = name.toLowerCase();
  if (!queryLower) return 0;
  if (nameLower === queryLower) return 10;
  if (nameLower.startsWith(queryLower)) return 5;
  if (nameLower.includes(queryLower)) return 2;
  const queryWords = queryLower.split(/\s+/).filter((w) => w.length > 0);
  const matchingWords = queryWords.filter((word) => nameLower.includes(word));
  if (matchingWords.length > 0) {
    return 1 * (matchingWords.length / queryWords.length);
  }
  return 0;
}
function getKnowledgebaseNameMatchScoreDiscoveryOnly(query, name) {
  const queryLower = query.toLowerCase().trim();
  const nameLower = name.toLowerCase();
  if (!queryLower) return 0;
  if (nameLower === queryLower) return 10;
  if (nameLower.startsWith(queryLower)) return 5;
  if (nameLower.includes(queryLower)) return 2;
  return 0;
}
function scoreKnowledgebaseChunk(query, chunk, nameMatchMode = "full") {
  const queryLower = query.toLowerCase().trim();
  const similarity = vectorDistanceToSimilarity(chunk.distance);
  const nameMatchScore = nameMatchMode === "discovery_only" ? getKnowledgebaseNameMatchScoreDiscoveryOnly(queryLower, chunk.name) : getKnowledgebaseNameMatchScore(queryLower, chunk.name);
  const contentMatchScore = getKnowledgebaseContentMatchScore(queryLower, chunk.content);
  const combinedScore = nameMatchScore * 2 + similarity + contentMatchScore * 1.5;
  return {
    distance: chunk.distance,
    similarity,
    nameMatchScore,
    combinedScore
  };
}
function finalizeKnowledgebaseSearchResults(input) {
  const { query, limit } = input;
  const queryLower = query.toLowerCase().trim();
  const scoredDocs = [];
  const seenIds = /* @__PURE__ */ new Set();
  const pushChunk = (chunk, nameMatchMode) => {
    if (seenIds.has(chunk.id)) return;
    seenIds.add(chunk.id);
    const { distance, similarity, nameMatchScore, combinedScore } = scoreKnowledgebaseChunk(
      query,
      chunk,
      nameMatchMode
    );
    scoredDocs.push({
      chunk,
      distance,
      similarity,
      nameMatchScore,
      combinedScore
    });
  };
  for (const h of input.vectorHits) {
    pushChunk(h, "full");
  }
  for (const h of input.extraHits ?? []) {
    pushChunk(h, "discovery_only");
  }
  const byDocument = /* @__PURE__ */ new Map();
  for (const item of scoredDocs) {
    const docKey = getKnowledgebaseDocumentKey(item.chunk.id ?? "", item.chunk.metadata ?? {});
    const existing = byDocument.get(docKey);
    if (!existing || item.combinedScore > existing.combinedScore) {
      byDocument.set(docKey, item);
    }
  }
  let finalDocs = [...byDocument.values()];
  finalDocs = finalDocs.filter((item) => item.similarity >= KB_SEARCH_MIN_SIMILARITY_THRESHOLD);
  const queryWordCount = query.trim().split(/\s+/).filter((w) => w.length > 0).length;
  if (queryWordCount <= KB_SEARCH_STRICT_SHORT_QUERY_MAX_WORDS) {
    finalDocs = finalDocs.filter((item) => {
      const contentMatch = getKnowledgebaseContentMatchScore(queryLower, item.chunk.content);
      if (contentMatch > 0) return true;
      return item.similarity >= KB_SEARCH_MIN_SIMILARITY_WITHOUT_CONTENT_MATCH;
    });
  }
  finalDocs.sort((a, b) => b.combinedScore - a.combinedScore);
  return finalDocs.slice(0, limit).map((item) => item.chunk);
}

// src/util/md5.ts
import * as jsMd5Import from "js-md5";
var jsMd5Fn = jsMd5Import.default ?? jsMd5Import;
var md5 = jsMd5Fn;

// src/library/knowledge/document.ts
var Document = class _Document {
  content;
  name;
  id;
  metadata;
  embedding;
  usage;
  constructor(content, name, id, metaData, embedding, usage) {
    this.content = content;
    this.name = name;
    this.id = id;
    this.metadata = metaData;
    this.embedding = embedding;
    this.usage = usage;
  }
  get cleanedContent() {
    let cleanedText = this.content.replace(/\n+/g, "\n");
    cleanedText = cleanedText.replace(/\s+/g, " ");
    cleanedText = cleanedText.replace(/\t+/g, "	");
    cleanedText = cleanedText.replace(/\r+/g, "\r");
    cleanedText = cleanedText.replace(/\f+/g, "\f");
    cleanedText = cleanedText.replace(/\v+/g, "\v");
    return cleanedText;
  }
  /**
   * Split content into chunks. Optional overlap reuses characters at the end of each chunk
   * at the start of the next (e.g. overlapChars = 0.1 * chunkSize for 10% overlap).
   */
  chunks(chunkSize, overlapChars = 0) {
    const cleanedContent = this.cleanedContent;
    const contentLength = cleanedContent.length;
    const chunkedDocuments = [];
    let chunkNumber = 1;
    const chunkMetaData = this.metadata || {};
    const overlap = Math.max(0, Math.min(overlapChars, chunkSize - 1));
    let start = 0;
    while (start < contentLength) {
      let end = start + chunkSize;
      if (end < contentLength) {
        while (end > start && cleanedContent[end] != void 0 && ![" ", "\n", "\r", "	"].includes(cleanedContent[end])) {
          end--;
        }
      }
      if (end == start) {
        end = start + chunkSize;
      }
      if (end > contentLength) {
        end = contentLength;
      }
      const chunk = cleanedContent.slice(start, end);
      const metaData = {
        ...chunkMetaData,
        chunk: chunkNumber,
        chunk_size: chunk.length,
        original_document_id: this.id || this.name
        // Store original document ID for deduplication
      };
      const chunkId = this.id ? `${this.id}_${chunkNumber}` : this.name ? `${this.name}_${chunkNumber}` : void 0;
      chunkedDocuments.push(new _Document(chunk, this.name, chunkId, metaData));
      chunkNumber++;
      start = overlap > 0 && end < contentLength ? end - overlap : end;
    }
    return chunkedDocuments;
  }
  get content_hash() {
    return md5(this.cleanedContent);
  }
};

// src/library/logging/log.ts
import { Logger as TsLogLoggerClass } from "tslog";
var TsLogLogger = TsLogLoggerClass;
var nameWidth = 24;
var pad = (str, width) => {
  if (str.length >= width) {
    return str.slice(0, width);
  }
  return str + " ".repeat(width - str.length);
};
var getLogger = (name, minLevel = 3, debug) => {
  if (debug) {
    minLevel = 0;
  }
  return new TsLogLogger({
    name: pad(name, nameWidth),
    prettyLogTemplate: "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}  {{logLevelName}}	{{name}}	",
    minLevel
  });
};

// src/library/context_catalog/catalog.ts
var logger = getLogger("ContextCatalog");
var ContextCatalog = class {
  sources = /* @__PURE__ */ new Map();
  register(source) {
    if (this.sources.has(source.id)) {
      logger.warn(`Context source with ID "${source.id}" is already registered`);
      return;
    }
    logger.info(`Registering context source: ${source.id} (${source.name})`);
    this.sources.set(source.id, source);
  }
  unregister(sourceId) {
    if (this.sources.delete(sourceId)) {
      logger.info(`Unregistered context source: ${sourceId}`);
    }
  }
  get(sourceId) {
    return this.sources.get(sourceId);
  }
  has(sourceId) {
    return this.sources.has(sourceId);
  }
  getSourceIds() {
    return Array.from(this.sources.keys());
  }
  getAllSources() {
    return Array.from(this.sources.values());
  }
  getAllItemTypes() {
    const result = /* @__PURE__ */ new Map();
    for (const [sourceId, source] of this.sources.entries()) {
      result.set(sourceId, source.getItemTypes());
    }
    return result;
  }
  getItemTypes(sourceId) {
    const source = this.sources.get(sourceId);
    return source?.getItemTypes();
  }
  async resolveItems(request) {
    logger.info(
      `ContextCatalog.resolveItems: sourceId=${request.sourceId}, itemTypeId=${request.itemTypeId}, registeredSourceIds=[${this.getSourceIds().join(", ")}]`
    );
    const source = this.sources.get(request.sourceId);
    if (!source) {
      logger.warn(`Context source "${request.sourceId}" not found. Available: ${this.getSourceIds().join(", ")}`);
      return void 0;
    }
    const items = await source.resolveItems(request);
    logger.info(`ContextCatalog.resolveItems: sourceId=${request.sourceId}, itemsCount=${items?.length ?? 0}`);
    if (!items || items.length === 0) {
      return void 0;
    }
    let itemTypeId = request.itemTypeId;
    if (!itemTypeId) {
      const itemTypes = source.getItemTypes();
      const firstItemType = itemTypes[0];
      if (firstItemType) {
        itemTypeId = firstItemType.id;
      } else {
        itemTypeId = "default";
      }
    }
    return {
      sourceId: request.sourceId,
      itemTypeId,
      items
    };
  }
  async resolveAsAdditionalContext(request) {
    const result = await this.resolveItems(request);
    if (!result) {
      return void 0;
    }
    const source = this.sources.get(result.sourceId);
    if (!source) {
      logger.warn(`Source ${result.sourceId} not found when converting to AdditionalContext`);
      return void 0;
    }
    return source.toAdditionalContext(result);
  }
  async resolveMultipleAsAdditionalContext(requests) {
    const results = await Promise.all(requests.map((request) => this.resolveAsAdditionalContext(request)));
    return results.filter((ctx) => ctx !== void 0);
  }
  clear() {
    logger.info("Clearing all context sources");
    this.sources.clear();
  }
};
var contextCatalog = new ContextCatalog();

// src/library/knowledge/knowledgebase.ts
var logger2 = getLogger("Knowledgebase");
var CONTEXT_SOURCE_ITEM_TYPES = [
  {
    id: "search",
    name: "Search Results",
    description: "Search results from the knowledgebase vector database"
  },
  {
    id: "document",
    name: "Document",
    description: "A specific document from the knowledgebase by ID"
  }
];
var Knowledgebase = class {
  id = "knowledgebase";
  name = "Knowledgebase";
  description = "Provides context from the vector database knowledgebase";
  vectorDbOrGetter;
  sources;
  sourcesMap;
  chunkSize;
  chunkOverlap;
  workspaceId;
  onDocumentIndexed;
  documentStorage;
  constructor(options) {
    this.vectorDbOrGetter = options.vectorDb;
    this.sources = options.sources;
    this.sourcesMap = /* @__PURE__ */ new Map();
    this.chunkSize = options.chunkSize;
    this.chunkOverlap = options.chunkOverlap;
    this.workspaceId = options.workspaceId;
    this.onDocumentIndexed = options.onDocumentIndexed;
    this.documentStorage = options.documentStorage;
    for (const source of this.sources) {
      this.sourcesMap.set(source.id, source);
    }
  }
  // --- ContextSource implementation ---
  getItemTypes() {
    return CONTEXT_SOURCE_ITEM_TYPES;
  }
  async resolveItems(request) {
    if (request.sourceId !== this.id) {
      return void 0;
    }
    const itemTypeId = request.itemTypeId || "search";
    try {
      if (itemTypeId === "search") {
        return await this.resolveSearch(request.params);
      } else if (itemTypeId === "document") {
        return await this.resolveDocument(request.params);
      }
      logger2.warn(`Unknown item type: ${itemTypeId}`);
      return void 0;
    } catch (error) {
      logger2.error(`Error resolving knowledgebase items:`, error);
      return void 0;
    }
  }
  async resolveSearch(params) {
    const query = params?.query;
    const limit = params?.limit || 5;
    if (!query) {
      logger2.warn("Search query not provided");
      return [];
    }
    const documents = await this.search(query, limit);
    return documents.map((doc) => this.documentToContextItem(doc));
  }
  async resolveDocument(params) {
    const documentId = params?.documentId;
    if (!documentId) {
      logger2.warn("Document ID not provided");
      return [];
    }
    const summaryOrChunk = params?.summaryOrChunk;
    if (summaryOrChunk !== void 0 && summaryOrChunk !== null) {
      const title = params?.title ?? "Document";
      return [
        {
          documentId,
          title,
          content: String(summaryOrChunk)
        }
      ];
    }
    if (!this.documentStorage) {
      logger2.warn("Document storage not available for knowledgebase context source");
      return [];
    }
    try {
      const doc = await this.documentStorage.getDocument(documentId);
      if (!doc) {
        logger2.warn(`Document ${documentId} not found in document storage`);
        return [];
      }
      return [this.documentToContextItem(doc)];
    } catch (error) {
      logger2.error(`Error fetching document ${documentId}:`, error);
      return [];
    }
  }
  documentToContextItem(doc) {
    const item = {
      content: doc.content,
      name: doc.name
    };
    if (doc.metadata?.url != null) item.url = String(doc.metadata.url);
    if (doc.metadata?.title != null) item.title = String(doc.metadata.title);
    return item;
  }
  toAdditionalContext(result) {
    const itemType = CONTEXT_SOURCE_ITEM_TYPES.find((type) => type.id === result.itemTypeId);
    const itemTypeName = itemType?.name || result.itemTypeId;
    return {
      name: `${this.name}: ${itemTypeName}`,
      description: itemType?.description || `Context from ${this.name}`,
      records: result.items
    };
  }
  get vectorDb() {
    const db = typeof this.vectorDbOrGetter === "function" ? this.vectorDbOrGetter() : this.vectorDbOrGetter;
    if (!db) {
      throw new Error("Vector database is not available");
    }
    return db;
  }
  async search(query, limit = 5) {
    let indexStats;
    try {
      indexStats = await this.vectorDb.getIndexStats(this.workspaceId);
    } catch (e) {
      logger2.warn("Knowledgebase.search: getIndexStats failed", e);
    }
    logger2.info(
      `[KbSearch] Knowledgebase.search start query=${JSON.stringify(query)} limit=${limit} workspaceId=${this.workspaceId ?? "(none)"} indexStats=${JSON.stringify(indexStats)}`
    );
    const currentDbDimensions = await this.vectorDb.getCurrentEmbeddingDimensions();
    const embedderDimensionsFromSchema = this.vectorDb.getEmbedderDimensions();
    logger2.info(
      `[KbSearch] dimensions dbSchema=${currentDbDimensions} vectorDbConfigured=${embedderDimensionsFromSchema}`
    );
    if (currentDbDimensions !== null && currentDbDimensions !== embedderDimensionsFromSchema) {
      logger2.warn(`Embedding dimensions mismatch: database has ${currentDbDimensions}, schema query returned ${embedderDimensionsFromSchema}. This shouldn't happen.`);
    }
    const results = await this.vectorDb.search(query, limit, this.workspaceId);
    logger2.info(
      `[KbSearch] Knowledgebase.search done query=${JSON.stringify(query)} returned=${results.length} document(s)`
    );
    return results;
  }
  async rebuild() {
    if (this.workspaceId) {
      logger2.info(`Rebuilding knowledgebase for workspace ${this.workspaceId} - deleting existing documents`);
      await this.vectorDb.deleteByWorkspaceId(this.workspaceId);
    } else {
      logger2.warn("Rebuilding knowledgebase without workspace_id - recreating all tables (this affects all workspaces)");
      await this.recreateTables();
    }
    for (const source of this.sources) {
      logger2.info(`Adding documents from ${source.id}`);
      await this.addAllFromSource(source);
    }
  }
  registerSource(source) {
    if (this.sourcesMap.has(source.id)) {
      logger2.warn(`Source ${source.id} is already registered`);
      return;
    }
    this.sources.push(source);
    this.sourcesMap.set(source.id, source);
    logger2.info(`Registered document source: ${source.id}`);
  }
  unregisterSource(sourceId) {
    if (!this.sourcesMap.has(sourceId)) {
      logger2.warn(`Source ${sourceId} is not registered`);
      return;
    }
    this.sources = this.sources.filter((s) => s.id !== sourceId);
    this.sourcesMap.delete(sourceId);
    logger2.info(`Unregistered document source: ${sourceId}`);
  }
  getSource(sourceId) {
    return this.sourcesMap.get(sourceId);
  }
  async reindexSource(sourceId) {
    const source = this.sourcesMap.get(sourceId);
    if (!source) {
      throw new Error(`Source ${sourceId} not found`);
    }
    logger2.info(`Re-indexing source: ${sourceId}`);
    await this.vectorDb.deleteBySourceId(sourceId, this.workspaceId);
    const documents = await source.documents();
    const documentsWithSourceId = documents.map((doc) => {
      const metadata = {
        ...doc.metadata,
        source_id: sourceId,
        ...this.workspaceId ? { workspace_id: this.workspaceId } : {}
      };
      return new Document(
        doc.content,
        doc.name,
        doc.id,
        metadata,
        doc.embedding,
        doc.usage
      );
    });
    await this.addAll(documentsWithSourceId);
    const finalCount = documentsWithSourceId.length;
    logger2.info(`Finished re-indexing source: ${sourceId}, indexed ${finalCount} documents`);
    return finalCount;
  }
  /**
   * Delete a single document (and its chunks) from the vector DB.
   * Use when an entity is removed from a source (e.g. data catalog delete).
   */
  async deleteDocument(sourceId, documentId) {
    const source = this.sourcesMap.get(sourceId);
    if (!source) {
      throw new Error(`Source ${sourceId} not found`);
    }
    await this.vectorDb.deleteBySourceIdAndDocumentId(
      sourceId,
      documentId,
      this.workspaceId
    );
    logger2.info(`Deleted document ${sourceId}/${documentId} from knowledgebase`);
  }
  /**
   * Re-index a single document from a source. Only runs if the source implements getDocument(id).
   * Returns true if the document was re-indexed, false if the source does not support single-doc reindex.
   */
  async reindexDocument(sourceId, documentId) {
    const source = this.sourcesMap.get(sourceId);
    if (!source?.getDocument) {
      return false;
    }
    const doc = await source.getDocument(documentId);
    if (!doc) {
      logger2.warn(`reindexDocument: no document ${documentId} in source ${sourceId}`);
      return true;
    }
    await this.vectorDb.deleteBySourceIdAndDocumentId(
      sourceId,
      documentId,
      this.workspaceId
    );
    const metadata = {
      ...doc.metadata,
      source_id: sourceId,
      ...this.workspaceId ? { workspace_id: this.workspaceId } : {}
    };
    const docWithSourceId = new Document(
      doc.content,
      doc.name,
      doc.id,
      metadata,
      doc.embedding,
      doc.usage
    );
    await this.addAll([docWithSourceId]);
    logger2.info(`Re-indexed single document: ${sourceId}/${documentId}`);
    return true;
  }
  add(document) {
    return this.addAll([document]);
  }
  async addAll(documents) {
    logger2.info(`Adding ${documents.length} documents`);
    if (this.onDocumentIndexed) {
      for (const document of documents) {
        try {
          this.onDocumentIndexed(document);
        } catch (err) {
          logger2.warn(`onDocumentIndexed failed for doc ${document.id ?? document.name}:`, err);
        }
      }
    }
    if (this.chunkSize) {
      const overlap = this.chunkOverlap ?? Math.floor(this.chunkSize * 0.1);
      logger2.info(`Chunking documents with chunk size: ${this.chunkSize}, overlap: ${overlap}`);
      const chunkedDocuments = [];
      for (const document of documents) {
        const chunks = document.chunks(this.chunkSize, overlap);
        const chunksWithWorkspaceId = chunks.map((chunk) => {
          const metadata = {
            ...chunk.metadata,
            ...this.workspaceId ? { workspace_id: this.workspaceId } : {}
          };
          return new Document(
            chunk.content,
            chunk.name,
            chunk.id,
            metadata,
            chunk.embedding,
            chunk.usage
          );
        });
        chunkedDocuments.push(...chunksWithWorkspaceId);
      }
      logger2.info(`Chunked into ${chunkedDocuments.length} chunks; inserting into vector DB`);
      documents = chunkedDocuments;
    } else {
      documents = documents.map((doc) => {
        if (doc.metadata?.workspace_id || !this.workspaceId) {
          return doc;
        }
        const metadata = {
          ...doc.metadata,
          workspace_id: this.workspaceId
        };
        return new Document(
          doc.content,
          doc.name,
          doc.id,
          metadata,
          doc.embedding,
          doc.usage
        );
      });
    }
    logger2.info(`Inserting ${documents.length} chunk(s) into vector DB`);
    await this.vectorDb.insert(documents, this.workspaceId);
    logger2.info(`Inserted ${documents.length} chunk(s) into vector DB`);
  }
  async addAllFromSource(source) {
    const documents = await source.documents();
    const documentsWithSourceId = documents.map((doc) => {
      const metadata = {
        ...doc.metadata,
        source_id: source.id,
        ...this.workspaceId ? { workspace_id: this.workspaceId } : {}
      };
      return new Document(
        doc.content,
        doc.name,
        doc.id,
        metadata,
        doc.embedding,
        doc.usage
      );
    });
    await this.addAll(documentsWithSourceId);
  }
  async recreateTables() {
    logger2.info("Recreating tables");
    return this.vectorDb.recreateTables();
  }
  initialize() {
    this.vectorDb.tableExists().then((exists) => {
      if (exists) {
        return;
      } else {
        this.recreateTables();
      }
    });
  }
  async getAllDocuments() {
    const allDocs = await this.vectorDb.getAllDocuments(this.workspaceId);
    const documentMap = /* @__PURE__ */ new Map();
    for (const doc of allDocs) {
      const metadata = doc.metadata || {};
      const isChunk = metadata.chunk !== void 0;
      if (isChunk) {
        const originalId = metadata.original_document_id;
        if (!originalId) {
          const extractedId = doc.id?.replace(/_\d+$/, "") || doc.name;
          const key = extractedId;
          if (!documentMap.has(key)) {
            const originalMetadata = { ...metadata };
            delete originalMetadata.chunk;
            delete originalMetadata.chunk_size;
            delete originalMetadata.original_document_id;
            const originalDoc = new Document(
              doc.content,
              doc.name,
              extractedId,
              originalMetadata,
              doc.embedding,
              doc.usage
            );
            documentMap.set(key, originalDoc);
          }
        } else {
          if (!documentMap.has(originalId)) {
            const originalMetadata = { ...metadata };
            delete originalMetadata.chunk;
            delete originalMetadata.chunk_size;
            delete originalMetadata.original_document_id;
            const originalDoc = new Document(
              doc.content,
              doc.name,
              originalId,
              originalMetadata,
              doc.embedding,
              doc.usage
            );
            documentMap.set(originalId, originalDoc);
          }
        }
      } else {
        const key = doc.id || doc.name || doc.content_hash || "";
        if (key && !documentMap.has(key)) {
          documentMap.set(key, doc);
        }
      }
    }
    return Array.from(documentMap.values());
  }
  /**
   * Returns the full content of a document by id. For chunked documents, concatenates all chunks
   * in order; for non-chunked documents, returns the single document's content.
   */
  async getFullDocumentContent(documentId) {
    const result = await this.getDocumentById(documentId);
    return result?.content ?? "";
  }
  /**
   * Fetches a document by ID. For chunked documents, concatenates all chunks in order and uses
   * the original document name; for non-chunked documents, returns the single document.
   * @returns Object with id, name, and full content, or null if not found
   */
  async getDocumentById(documentId) {
    const allRows = await this.vectorDb.getAllDocuments(this.workspaceId);
    const chunks = [];
    let wholeDoc = null;
    for (const doc of allRows) {
      const metadata = doc.metadata || {};
      const isChunk = metadata.chunk !== void 0;
      const originalId = metadata.original_document_id;
      if (isChunk && originalId === documentId) {
        const chunkIndex = typeof metadata.chunk === "number" ? metadata.chunk : parseInt(String(metadata.chunk), 10) || 0;
        chunks.push({ chunkIndex, content: doc.content ?? "", name: doc.name ?? documentId });
      } else if (!isChunk && (doc.id === documentId || doc.name === documentId)) {
        wholeDoc = doc;
      }
    }
    if (wholeDoc) {
      return {
        id: wholeDoc.id ?? documentId,
        name: wholeDoc.name ?? documentId,
        content: wholeDoc.content ?? ""
      };
    }
    if (chunks.length === 0) {
      return null;
    }
    chunks.sort((a, b) => a.chunkIndex - b.chunkIndex);
    const name = chunks[0]?.name ?? documentId;
    const content = chunks.map((c) => c.content).join("");
    return { id: documentId, name, content };
  }
  async reEmbedAllDocuments(onProgress, targetDimensions) {
    logger2.info("Starting re-embedding of all documents");
    if (targetDimensions !== void 0) {
      const dimensionsUpdated = await this.vectorDb.updateEmbeddingDimensions(targetDimensions);
      if (dimensionsUpdated) {
        onProgress?.(0, 0, `Updated embedding dimensions to ${targetDimensions}, starting re-embedding...`);
      }
    }
    await this.vectorDb.reEmbedAllDocuments(onProgress);
    logger2.info("Finished re-embedding all documents");
  }
  async getCurrentEmbeddingDimensions() {
    return this.vectorDb.getCurrentEmbeddingDimensions();
  }
};

// src/util/zod.ts
import * as zodPkg from "zod";
var z2 = zodPkg.z;

// src/library/util/strings.ts
function dedent(strings, ...interps) {
  let string = "";
  for (let i = 0; i < strings.length; i++) {
    string += (strings[i] || "") + (interps[i] ? "{" + i + "}" : "");
  }
  string = string.replace(/^[\r\n]+/, "").replace(/\s+$/, "");
  const dents = string.match(/^([ \t])*/gm)?.filter((dent) => dent.length > 0) || [];
  let cleaned = string;
  if (dents && dents.length > 0) {
    dents.sort((dent1, dent2) => dent1.length - dent2.length);
    const minDent = dents[0];
    if (minDent) {
      cleaned = string.replace(new RegExp(`^${minDent}`, "gm"), "");
    }
  }
  for (let i = 0; i < interps.length; i++) {
    cleaned = cleaned.replace(`{${i}}`, interps[i]);
  }
  return cleaned;
}

// src/library/assistant/tools.ts
import { ZodError } from "zod";

// src/library/util/json_schema_from_zod.ts
import { toJSONSchema } from "zod";
function zodToJsonSchema(schema) {
  const payload = toJSONSchema(schema, { target: "draft-07" });
  return Object.fromEntries(
    Object.entries(payload).filter(([k]) => k !== "~standard" && k !== "$schema")
  );
}

// src/library/util/json_handling.ts
function sanitizeControlCharacters(json) {
  let inString = false;
  let escaped = false;
  let output = "";
  for (let i = 0; i < json.length; i++) {
    const char = json[i];
    const charCode = char.charCodeAt(0);
    if (escaped) {
      output += char;
      escaped = false;
      continue;
    }
    if (char === "\\") {
      escaped = true;
      output += char;
      continue;
    }
    if (char === '"') {
      inString = !inString;
      output += char;
      continue;
    }
    if (inString) {
      if (charCode < 32) {
        switch (char) {
          case "\n":
            output += "\\n";
            break;
          case "\r":
            output += "\\r";
            break;
          case "	":
            output += "\\t";
            break;
          case "\b":
            output += "\\b";
            break;
          case "\f":
            output += "\\f";
            break;
          default:
            output += `\\u${charCode.toString(16).padStart(4, "0")}`;
        }
      } else {
        output += char;
      }
    } else {
      output += char;
    }
  }
  return output;
}
function repairJSON(json) {
  let repaired = json.trim();
  try {
    const sanitized = sanitizeControlCharacters(repaired);
    JSON.parse(sanitized);
    return sanitized;
  } catch {
  }
  repaired = repaired.replace(/,(\s*[}\]])/g, "$1").replace(/,(\s*\n\s*[}\]])/g, "$1").replace(/([{[])\s*,/g, "$1").replace(/,{2,}/g, ",").replace(/:\s*,/g, ": null,").replace(/:\s*([}\]])/g, ": null$1");
  repaired = sanitizeControlCharacters(repaired);
  return repaired;
}
function extractJsonArraySubstring(text) {
  const start = text.indexOf("[");
  if (start === -1) return void 0;
  let depth = 0;
  let inString = false;
  let escaped = false;
  for (let i = start; i < text.length; i++) {
    const c = text[i];
    if (escaped) {
      escaped = false;
      continue;
    }
    if (inString) {
      if (c === "\\") {
        escaped = true;
        continue;
      }
      if (c === '"') {
        inString = false;
      }
      continue;
    }
    if (c === '"') {
      inString = true;
      continue;
    }
    if (c === "[") depth++;
    else if (c === "]") {
      depth--;
      if (depth === 0) {
        return text.slice(start, i + 1);
      }
    }
  }
  return void 0;
}
function extractJsonObjectSubstring(text) {
  const start = text.indexOf("{");
  if (start === -1) return void 0;
  let depth = 0;
  let inString = false;
  let escaped = false;
  for (let i = start; i < text.length; i++) {
    const c = text[i];
    if (escaped) {
      escaped = false;
      continue;
    }
    if (inString) {
      if (c === "\\") {
        escaped = true;
        continue;
      }
      if (c === '"') {
        inString = false;
      }
      continue;
    }
    if (c === '"') {
      inString = true;
      continue;
    }
    if (c === "{") depth++;
    else if (c === "}") {
      depth--;
      if (depth === 0) {
        return text.slice(start, i + 1);
      }
    }
  }
  return void 0;
}
var extractJSON = (text) => {
  if (text && text.length > 0) {
    try {
      JSON.parse(text);
      return { json: text, valid: true };
    } catch (e) {
    }
    const jsonWithGuards = Array.from(text.matchAll(/```json(.*?)```/gs));
    if (jsonWithGuards.length > 0) {
      const json = jsonWithGuards[0][1];
      if (json && json.length > 0) {
        try {
          JSON.parse(json);
          return { json, valid: true };
        } catch (e) {
          try {
            const repaired = repairJSON(json);
            JSON.parse(repaired);
            return { json: repaired, valid: true };
          } catch (repairError) {
            return { json, valid: false, error: e.message };
          }
        }
      }
    }
    const jsonWithoutGuards = text.match(/.*?({.*?}).*/s);
    if (jsonWithoutGuards && jsonWithoutGuards.length > 1) {
      const json = jsonWithoutGuards[1];
      if (json && json.length > 0) {
        try {
          JSON.parse(json);
          return { json, valid: true };
        } catch (e) {
          try {
            const repaired = repairJSON(json);
            JSON.parse(repaired);
            return { json: repaired, valid: true };
          } catch (repairError) {
            return { json, valid: false, error: e.message };
          }
        }
      }
    }
  }
  return void 0;
};

// src/library/assistant/tools.ts
var AssistantTool = class {
  examples;
  async invoke(input, context) {
    return this.exec(input, context).then((result) => {
      return {
        success: true,
        result
      };
    }).catch((error) => {
      if (error instanceof ZodError) {
        const msg = error.flatten().formErrors?.join("; ") ?? error.message;
        return {
          success: false,
          error: `Validation error: ${msg}`
        };
      }
      if (error instanceof Error) {
        return {
          success: false,
          error: error.message
        };
      }
      return {
        success: false,
        error: "An unknown error occurred"
      };
    });
  }
};
var defineTool = (config) => {
  return class extends AssistantTool {
    id = config.id;
    purpose = config.purpose;
    description = config.description;
    parameters = config.parameters;
    results = ToolResultsSchema(config.results);
    examples = config.examples;
    exec = config.exec;
  };
};
function ToolResultsSchema(resultSchema) {
  const base = z2.object({
    success: z2.boolean().describe("Whether the tool succeeded"),
    error: z2.string().optional().describe("An error message if the tool failed")
  });
  if (resultSchema) {
    return base.extend({ result: resultSchema.optional() });
  }
  return base;
}
var AssistantToolInstructions = (tool) => {
  const sections = [];
  sections.push(`<tool id="${tool.id}">`);
  sections.push(`  <purpose>${tool.purpose}</purpose>`);
  sections.push(`  <description>${tool.getDescription?.() ?? tool.description}</description>`);
  const paramsJson = JSON.stringify(zodToJsonSchema(tool.parameters), null, 2);
  sections.push("  <input_schema>");
  sections.push("    The input parameters for this tool must match the following JSON schema:");
  sections.push("    ```json");
  sections.push(paramsJson.split("\n").map((line) => `    ${line}`).join("\n"));
  sections.push("    ```");
  sections.push("  </input_schema>");
  const resultsJson = JSON.stringify(zodToJsonSchema(tool.results), null, 2);
  sections.push("  <output_schema>");
  sections.push("    The tool will return results matching the following JSON schema:");
  sections.push("    ```json");
  sections.push(resultsJson.split("\n").map((line) => `    ${line}`).join("\n"));
  sections.push("    ```");
  sections.push("  </output_schema>");
  if (tool.examples && tool.examples.length > 0) {
    sections.push("  <examples>");
    tool.examples.forEach((example, idx) => {
      const inputJson = JSON.stringify(example.input, null, 2);
      const outputJson = JSON.stringify(example.output, null, 2);
      sections.push(`    <example number="${idx + 1}">`);
      if (example.explanation) {
        sections.push(`      <explanation>${example.explanation}</explanation>`);
      }
      sections.push("      <input>");
      sections.push("        ```json");
      sections.push(inputJson.split("\n").map((line) => `        ${line}`).join("\n"));
      sections.push("        ```");
      sections.push("      </input>");
      sections.push("      <output>");
      sections.push("        ```json");
      sections.push(outputJson.split("\n").map((line) => `        ${line}`).join("\n"));
      sections.push("        ```");
      sections.push("      </output>");
      sections.push(`    </example>`);
    });
    sections.push("  </examples>");
  }
  sections.push("</tool>");
  return sections.join("\n");
};
var logger3 = getLogger("ToolHandler");
var ToolParseError = class extends Error {
  block;
  constructor(message, block) {
    super(message);
    this.name = "ToolParseError";
    this.block = block;
  }
};
var ExtractToolHelpRequests = (input) => {
  const helpBlocks = input.match(/<tool_help tool_id="([\s\S]*?)"\/>/g);
  if (!helpBlocks || helpBlocks.length === 0) {
    return [];
  }
  return helpBlocks.map((block) => {
    return block.match(/<tool_help tool_id="([\s\S]*?)"\/>/)[1];
  }).filter((block) => block !== void 0);
};
function parseToolsBlock(block) {
  const trimmed = block.trim();
  let toolsJSON = extractJSON(trimmed);
  if (toolsJSON === void 0) {
    const arr = extractJsonArraySubstring(trimmed);
    if (arr) {
      try {
        JSON.parse(arr);
        toolsJSON = { json: arr, valid: true };
      } catch {
        try {
          const repaired = repairJSON(arr);
          JSON.parse(repaired);
          toolsJSON = { json: repaired, valid: true };
        } catch {
        }
      }
    }
  }
  if (toolsJSON === void 0) {
    const obj = extractJsonObjectSubstring(trimmed);
    if (obj) {
      try {
        JSON.parse(obj);
        toolsJSON = { json: obj, valid: true };
      } catch {
        try {
          const repaired = repairJSON(obj);
          JSON.parse(repaired);
          toolsJSON = { json: repaired, valid: true };
        } catch {
        }
      }
    }
  }
  if (toolsJSON === void 0) {
    throw new ToolParseError(
      `A tools request was found but no valid, parseable, JSON array or object exists in the request.`,
      block
    );
  }
  if (!toolsJSON.valid) {
    throw new ToolParseError(
      `Something JSON-like was found in tools request but there was an error parsing it: ${toolsJSON.error}`,
      block
    );
  }
  let parsed;
  try {
    parsed = JSON.parse(toolsJSON.json);
  } catch {
    try {
      parsed = JSON.parse(repairJSON(toolsJSON.json));
    } catch {
      throw new ToolParseError(`Invalid JSON in tools request`, block);
    }
  }
  const asRequest = (raw) => {
    if (!raw || typeof raw !== "object") {
      throw new ToolParseError(`Invalid tool entry: '${JSON.stringify(raw)}'`, block);
    }
    const r = raw;
    if (typeof r.tool !== "string" || !r.tool) {
      throw new ToolParseError(
        `Tool request is missing a tool ID - request JSON was '${JSON.stringify(raw)}'`,
        block
      );
    }
    const params = r.parameters;
    const parameters = params != null && typeof params === "object" && !Array.isArray(params) ? params : {};
    return { tool: r.tool, parameters };
  };
  if (Array.isArray(parsed)) {
    return parsed.map((item) => asRequest(item));
  }
  if (typeof parsed === "object" && parsed !== null && typeof parsed.tool === "string") {
    return [asRequest(parsed)];
  }
  throw new ToolParseError(
    `Tools request must be a JSON array or a single object with "tool" and optional "parameters": '${JSON.stringify(parsed)}'`,
    block
  );
}
function contentLooksLikeEmbeddedToolsRequest(content) {
  return /<\s*tools\b/i.test(content);
}
var ExtractToolsRequests = (input) => {
  const result = new Array();
  const closedRe = /<\s*tools\s*>([\s\S]*?)<\s*\/\s*tools\s*>/gi;
  const closed = [...input.matchAll(closedRe)];
  const blocks = [];
  if (closed.length > 0) {
    for (const m of closed) {
      if (m[1] !== void 0) {
        blocks.push(m[1]);
      }
    }
  } else if (contentLooksLikeEmbeddedToolsRequest(input)) {
    const open = input.match(/<\s*tools\s*>([\s\S]*)/i);
    if (open?.[1] !== void 0) {
      blocks.push(open[1]);
    }
  }
  for (const block of blocks) {
    result.push(...parseToolsBlock(block));
  }
  return result;
};

// src/library/knowledge/knowledgebase_tool.ts
var logger4 = getLogger("KnowledgebaseTool");
function logicalDocumentIdForKbFetch(doc) {
  const meta = doc.metadata;
  const original = meta?.original_document_id;
  if (typeof original === "string" && original.trim() !== "") {
    return original.trim();
  }
  const id = doc.id;
  if (typeof id === "string" && id.length > 0) {
    const m = id.match(/^(.*)_(\d+)$/);
    if (m?.[1]) {
      return m[1];
    }
    return id;
  }
  const n = doc.name;
  return typeof n === "string" && n.trim() !== "" ? n.trim() : "";
}
var documentMetadataSchema = z2.object({
  title: z2.string().describe("The title of the document"),
  url: z2.string().describe("The URL of the document")
});
var documentSchema = z2.object({
  documentId: z2.string().describe(
    "Pass this exact string as the documentId argument to fetch the full indexed document. For search hits it is the logical source id (matches vector metadata), not necessarily the display filename in title/name."
  ),
  chunkId: z2.string().optional().describe("Storage id for this excerpt (chunk row id). Optional; use documentId to load the full logical document."),
  content: z2.string().describe("The content of the document"),
  metadata: documentMetadataSchema.describe("The metadata of the document"),
  purpose: z2.string().describe("Human-readable label (often the source file or document name)")
});
var KnowledgebaseTool = class extends defineTool({
  id: "search_knowledgebase",
  purpose: "Search or fetch from Knowledgebase",
  description: dedent`
        Search the workspace Knowledgebase (vector index over user-uploaded documents, notes, library or directory sources, and other indexed material) or fetch a full document by ID.
        Each search hit includes documentId (logical source id for getDocumentById) and optional chunkId (this excerpt's row id)—use documentId for full fetches, not the display filename alone.
        Search returns short excerpts, not necessarily whole files—if the first query misses the fact, try again with different wording (project or product name, acronyms, headings, dates, error codes, API or config keys, policy section titles, people's names, etc.).
        For the **verbatim** full body of a user **library** note or upload (canonical storage, not KB reassembly), call **get_library_document** with the same UUID after you know which row you need.
        Content can be anything the user indexed: e.g. runbooks, specs, meeting notes, legal or HR policies, research papers, markdown, spreadsheets exported to text, or long PDFs. For large sources, combine documentId with targeted follow-up queries.
    `,
  parameters: z2.object({
    query: z2.string().optional().describe(
      "Natural-language search; returns ranked text chunks. Omit when using documentId. If results are empty or off-topic, retry with synonyms, narrower technical terms, alternate names for the same concept, or phrases that might appear in a different doc type\u2014do not assume nothing is indexed after a single vague query."
    ),
    documentId: z2.string().optional().describe(
      "Logical indexed document id (use the documentId field from a prior search hit, not the display title alone). Returns assembled full text for that source. Omit when using query."
    ),
    limit: z2.number().optional().describe(
      "Max chunk results for query search (default 10, cap 50). Raise modestly when you need more snippets from a long or wide-ranging source. Ignored when documentId is used."
    )
  }),
  results: z2.object({
    documents: z2.array(documentSchema).describe("The documents found in the Knowledgebase")
  }),
  exec: async () => {
    throw new Error("Not implemented");
  }
}) {
  constructor(knowledgeBase) {
    super();
    this.knowledgeBase = knowledgeBase;
    this.exec = async (input) => {
      logger4.info(`[KbSearch] KnowledgebaseTool.invoke ${JSON.stringify(input)}`);
      const { query, documentId } = input;
      const rawLimit = input.limit;
      const limit = typeof rawLimit === "number" && Number.isFinite(rawLimit) && rawLimit > 0 ? Math.min(50, Math.max(1, Math.floor(rawLimit))) : 10;
      if (documentId != null && documentId !== "") {
        const doc = await this.knowledgeBase.getDocumentById(documentId);
        const documents = doc ? [{
          documentId: doc.id,
          content: doc.content,
          metadata: { title: doc.name, url: "" },
          purpose: doc.name
        }] : [];
        logger4.info(
          `[KbSearch] KnowledgebaseTool documentId=${JSON.stringify(documentId)} found=${documents.length} contentChars=${documents[0]?.content?.length ?? 0}`
        );
        return { documents };
      }
      if (query == null || query === "") {
        logger4.info("[KbSearch] KnowledgebaseTool empty query; returning no documents");
        return { documents: [] };
      }
      const docs = await this.knowledgeBase.search(query, limit);
      logger4.info(
        `[KbSearch] KnowledgebaseTool search query=${JSON.stringify(query)} limit=${limit} rawResults=${docs.length}`
      );
      return {
        documents: docs.map((d) => {
          const chunkId = typeof d.id === "string" && d.id.length > 0 ? d.id : void 0;
          return {
            documentId: logicalDocumentIdForKbFetch(d),
            ...chunkId ? { chunkId } : {},
            content: d.content,
            metadata: {
              title: String(d.metadata?.title ?? d.name ?? ""),
              url: String(d.metadata?.url ?? "")
            },
            purpose: d.name
          };
        })
      };
    };
  }
  knowledgeBase;
};

// src/library/knowledge/get_library_document_tool.ts
var logger5 = getLogger("GetLibraryDocumentTool");
var GetLibraryDocumentTool = class extends defineTool({
  id: "get_library_document",
  purpose: "Download the full contents of a workspace library document",
  description: dedent`
    Returns the complete text (and title) for a document in the user's **library** (uploads and notes), preferring live library storage over reassembling knowledgebase chunks.
    Use when \`search_knowledgebase\` excerpts are not enough—long PDFs, full notes, or verbatim file bodies.
    Pass the library document **UUID** (from the Documents list or from a search hit's \`documentId\` when it refers to a user library row).
  `,
  parameters: z2.object({
    documentId: z2.string().describe("Library document id (UUID).")
  }),
  results: z2.object({
    documentId: z2.string(),
    name: z2.string(),
    content: z2.string(),
    mimeType: z2.string().nullable().optional(),
    source: z2.enum(["library", "knowledgebase"])
  }),
  exec: async () => {
    throw new Error("Not implemented");
  }
}) {
  constructor(fetchDocument) {
    super();
    this.fetchDocument = fetchDocument;
    this.exec = async (input) => {
      const id = typeof input.documentId === "string" ? input.documentId.trim() : "";
      if (!id) {
        throw new Error("documentId is required");
      }
      logger5.info(`[LibraryDoc] get_library_document id=${JSON.stringify(id)}`);
      const doc = await this.fetchDocument(id);
      if (!doc) {
        throw new Error(`Library document not found: ${id}`);
      }
      return {
        documentId: doc.documentId,
        name: doc.name,
        content: doc.content,
        mimeType: doc.mimeType ?? null,
        source: doc.source
      };
    };
  }
  fetchDocument;
};

// src/library/knowledge/user_document_kb_index.ts
var USER_DOCUMENT_KB_SOURCE_PREFIX = "user_document:";
var DEFAULT_USER_DOCUMENT_KB_CHUNK_SIZE = 2048;
function isNonIndexableUserDocumentContent(content) {
  const t = content.trim().toLowerCase();
  if (t.length === 0) return true;
  const placeholders = [
    "(no extractable text)",
    "(no text content)",
    "(pdf could not be embedded; file may be too large)"
  ];
  return placeholders.includes(t);
}
function resolveUserDocumentKbSourceId(documentId, existingSourceId) {
  const t = typeof existingSourceId === "string" ? existingSourceId.trim() : "";
  if (t !== "" && !t.startsWith(USER_DOCUMENT_KB_SOURCE_PREFIX)) return t;
  return `${USER_DOCUMENT_KB_SOURCE_PREFIX}${documentId}`;
}
function buildUserDocumentKbParentDocument(input) {
  const baseForSourceId = input.defaultSourceIdDocumentId ?? input.kbDocumentId;
  const sourceId = resolveUserDocumentKbSourceId(baseForSourceId, input.metadata?.source_id);
  const metadata = {
    ...input.metadata ?? {},
    workspace_id: input.workspaceId,
    source_id: sourceId
  };
  if (metadata.blob !== void 0) delete metadata.blob;
  if (input.mimeType != null && metadata.mimeType === void 0) {
    metadata.mimeType = input.mimeType;
  }
  return new Document(input.content, input.name, input.kbDocumentId, metadata);
}
async function indexUserDocumentParentIntoKnowledgebase(input) {
  const wid = input.workspaceId;
  const sourceId = input.parent.metadata?.source_id;
  if (typeof sourceId !== "string" || sourceId.trim() === "") {
    throw new Error("indexUserDocumentParentIntoKnowledgebase: parent.metadata.source_id is required");
  }
  if (input.vectorDb && wid) {
    await input.vectorDb.deleteBySourceId(sourceId, wid);
  }
  await input.knowledgebase.add(input.parent);
}

// src/library/knowledge/trpc_auto_embedding_embedder.ts
var CLOUD_EMBEDDING_DIMENSIONS = 512;
function normalizeEmbeddingVector(embedding, expected) {
  if (embedding.length > expected) return embedding.slice(0, expected);
  if (embedding.length < expected) {
    return [...embedding, ...new Array(expected - embedding.length).fill(0)];
  }
  return embedding;
}
var TrpcAutoEmbeddingEmbedder = class {
  constructor(embeddings) {
    this.embeddings = embeddings;
  }
  embeddings;
  dimensions = CLOUD_EMBEDDING_DIMENSIONS;
  displayName = "Owlbert Backend (auto)";
  async getEmbedding(text) {
    const response = await this.embeddings.createAutoEmbeddings.mutate({
      input: text,
      dimensions: CLOUD_EMBEDDING_DIMENSIONS
    });
    let embedding = response?.data?.[0]?.embedding;
    if (!embedding || !Array.isArray(embedding) || embedding.length === 0) {
      throw new Error("Embeddings returned no vector for knowledgebase chunk.");
    }
    return normalizeEmbeddingVector(embedding, CLOUD_EMBEDDING_DIMENSIONS);
  }
  async getQueryEmbedding(query) {
    return this.getEmbedding(query);
  }
};

// src/library/knowledge/trpc_cloud_vector_db.ts
var logger6 = getLogger("TrpcCloudVectorDb");
var CLOUD_EMBEDDING_DIMENSIONS2 = 512;
var GET_EMBEDDING_DIMENSIONS_INITIAL_BACKOFF_MS = 250;
var GET_EMBEDDING_DIMENSIONS_MAX_BACKOFF_MS = 3e4;
var GET_EMBEDDING_DIMENSIONS_CACHE_MS = 3e4;
var getEmbeddingDimensionsBackoffUntil = 0;
var getEmbeddingDimensionsFailureCount = 0;
var getEmbeddingDimensionsCached = null;
function embedderLabel(embedder) {
  const d = embedder.displayName?.trim();
  if (d) return `${d} (${embedder.dimensions}d)`;
  const ctor = embedder.constructor?.name;
  const base = ctor && ctor !== "Object" ? ctor : "Embedder";
  return `${base} (${embedder.dimensions}d)`;
}
var TrpcCloudVectorDb = class {
  client;
  workspaceId;
  embedder;
  beforeRequest;
  getUseHostedProcedureRemotes;
  constructor(options) {
    this.client = options.client;
    this.workspaceId = options.workspaceId;
    this.embedder = options.embedder;
    this.beforeRequest = options.beforeRequest;
    this.getUseHostedProcedureRemotes = options.getUseHostedProcedureRemotes;
    if (this.embedder.dimensions !== CLOUD_EMBEDDING_DIMENSIONS2) {
      logger6.warn(
        `Cloud vector DB expects ${CLOUD_EMBEDDING_DIMENSIONS2} dimensions; embedder has ${this.embedder.dimensions}. Search/insert may fail.`
      );
    }
  }
  useHostedRemotes() {
    return this.getUseHostedProcedureRemotes?.() ?? false;
  }
  async getIndexStats(_workspaceId) {
    return { documentRows: -1, embeddingRows: -1, distinctLogicalDocuments: -1 };
  }
  async search(query, limit, workspaceId) {
    await this.beforeRequest?.();
    const wid = workspaceId ?? this.workspaceId;
    const embedderStr = embedderLabel(this.embedder);
    const backendLimit = Math.min(limit * 8, 500);
    logger6.info(
      `[KbSearch/Cloud] start query=${JSON.stringify(query)} limit=${limit} workspaceId=${wid} embedder=${embedderStr} backendFetchLimit=${backendLimit} (local indexStats not loaded; use -1 sentinel)`
    );
    const queryEmbedding = await this.embedder.getQueryEmbedding(query);
    logger6.debug(`[KbSearch/Cloud] query embedding dim=${queryEmbedding.length}`);
    const searchPayload = {
      queryEmbedding,
      limit: backendLimit,
      workspaceId: wid
    };
    const rows = this.useHostedRemotes() ? await remoteKnowledgebaseSearch(this.client.knowledgebase, searchPayload) : await this.client.knowledgebase.search.mutate(searchPayload);
    const vectorHits = rows.map((r) => ({
      id: r.id,
      name: r.name,
      content: r.content,
      metadata: r.metadata ?? {},
      usage: r.usage,
      content_hash: r.content_hash,
      distance: typeof r.distance === "number" && !Number.isNaN(r.distance) ? r.distance : 1
    }));
    const ranked = finalizeKnowledgebaseSearchResults({ query, limit, vectorHits });
    const documents = ranked.map(
      (r) => new Document(r.content, r.name, r.id, r.metadata ?? {}, void 0, r.usage)
    );
    logger6.info(
      `[KbSearch/Cloud] done query=${JSON.stringify(query)} backendRows=${rows.length} afterRank=${ranked.length} returned=${documents.length}`
    );
    return documents;
  }
  async insert(documents, workspaceId) {
    await this.beforeRequest?.();
    const wid = workspaceId ?? this.workspaceId;
    const needEmbedding = documents.filter((d) => !d.embedding);
    const EMBEDDING_CONCURRENCY = 10;
    if (needEmbedding.length > 0) {
      logger6.info(`Computing embeddings for ${needEmbedding.length} chunk(s) before cloud insert`);
      for (let i = 0; i < needEmbedding.length; i += EMBEDDING_CONCURRENCY) {
        const chunk = needEmbedding.slice(i, i + EMBEDDING_CONCURRENCY);
        const embeddings = await Promise.all(chunk.map((doc) => this.embedder.getEmbedding(doc.cleanedContent)));
        chunk.forEach((doc, j) => {
          doc.embedding = embeddings[j];
        });
      }
    }
    const payload = documents.map((doc) => {
      const docId = doc.id ?? doc.content_hash;
      if (!docId) {
        throw new Error("Document must have either an id or content_hash");
      }
      const embedding = doc.embedding;
      if (!embedding || embedding.length !== CLOUD_EMBEDDING_DIMENSIONS2) {
        throw new Error(`Each document must have an embedding of length ${CLOUD_EMBEDDING_DIMENSIONS2} for cloud insert`);
      }
      return {
        id: docId,
        name: doc.name,
        content: doc.content,
        meta_data: doc.metadata ?? {},
        usage: doc.usage ?? null,
        content_hash: doc.content_hash ?? null,
        embedding
      };
    });
    const insertPayload = {
      workspaceId: wid,
      documents: payload
    };
    if (this.useHostedRemotes()) {
      await remoteKnowledgebaseInsert(this.client.knowledgebase, insertPayload);
    } else {
      await this.client.knowledgebase.insert.mutate(insertPayload);
    }
    logger6.info(`Inserted ${documents.length} chunk(s) into cloud vector DB`);
  }
  async deleteBySourceId(sourceId, workspaceId) {
    await this.beforeRequest?.();
    const wid = workspaceId ?? this.workspaceId;
    const delSrc = { workspaceId: wid, sourceId };
    if (this.useHostedRemotes()) {
      await remoteKnowledgebaseDeleteBySourceId(this.client.knowledgebase, delSrc);
    } else {
      await this.client.knowledgebase.deleteBySourceId.mutate(delSrc);
    }
  }
  async deleteBySourceIdAndDocumentId(sourceId, documentId, workspaceId) {
    await this.beforeRequest?.();
    const wid = workspaceId ?? this.workspaceId;
    const delPair = { workspaceId: wid, sourceId, documentId };
    if (this.useHostedRemotes()) {
      await remoteKnowledgebaseDeleteBySourceIdAndDocumentId(this.client.knowledgebase, delPair);
    } else {
      await this.client.knowledgebase.deleteBySourceIdAndDocumentId.mutate(delPair);
    }
  }
  async deleteByWorkspaceId(workspaceId) {
    await this.beforeRequest?.();
    const delWs = { workspaceId: workspaceId ?? this.workspaceId };
    if (this.useHostedRemotes()) {
      await remoteKnowledgebaseDeleteByWorkspaceId(this.client.knowledgebase, delWs);
    } else {
      await this.client.knowledgebase.deleteByWorkspaceId.mutate(delWs);
    }
  }
  async getAllDocuments(workspaceId) {
    await this.beforeRequest?.();
    const wid = workspaceId ?? this.workspaceId;
    const rows = this.useHostedRemotes() ? await remoteKnowledgebaseGetAllDocuments(this.client.knowledgebase, { workspaceId: wid }) : await this.client.knowledgebase.getAllDocuments.query({
      workspaceId: wid
    });
    return rows.map(
      (r) => new Document(r.content, r.name, r.id, r.metadata ?? {}, void 0, r.usage)
    );
  }
  async recreateTables() {
    await this.deleteByWorkspaceId(this.workspaceId);
  }
  async tableExists() {
    await this.beforeRequest?.();
    return this.useHostedRemotes() ? remoteKnowledgebaseTableExists(this.client.knowledgebase) : this.client.knowledgebase.tableExists.query();
  }
  async reEmbedAllDocuments(onProgress) {
    const all = await this.getAllDocuments(this.workspaceId);
    const total = all.length;
    onProgress?.(0, total, `Re-embedding ${total} documents in cloud...`);
    if (total === 0) {
      onProgress?.(0, 0, "Re-embedding complete!");
      return;
    }
    await this.deleteByWorkspaceId(this.workspaceId);
    const EMBEDDING_CONCURRENCY = 10;
    for (let i = 0; i < all.length; i += EMBEDDING_CONCURRENCY) {
      const chunk = all.slice(i, i + EMBEDDING_CONCURRENCY);
      const embeddings = await Promise.all(chunk.map((doc) => this.embedder.getEmbedding(doc.cleanedContent)));
      chunk.forEach((doc, j) => {
        doc.embedding = embeddings[j];
      });
      await this.insert(chunk, this.workspaceId);
      onProgress?.(
        Math.min(i + EMBEDDING_CONCURRENCY, total),
        total,
        `Re-embedded ${Math.min(i + EMBEDDING_CONCURRENCY, total)} of ${total}`
      );
    }
    onProgress?.(total, total, "Re-embedding complete!");
  }
  async updateEmbeddingDimensions(_targetDimensions) {
    return false;
  }
  async getCurrentEmbeddingDimensions() {
    const now = Date.now();
    if (getEmbeddingDimensionsCached && now < getEmbeddingDimensionsCached.until) {
      return getEmbeddingDimensionsCached.value;
    }
    if (now < getEmbeddingDimensionsBackoffUntil) {
      const remainingMs = getEmbeddingDimensionsBackoffUntil - now;
      logger6.info(
        `Backing off getEmbeddingDimensions (${Math.ceil(remainingMs / 1e3)}s remaining after previous failure)`
      );
      return null;
    }
    try {
      await this.beforeRequest?.();
      const result = this.useHostedRemotes() ? await remoteKnowledgebaseGetEmbeddingDimensions(this.client.knowledgebase) : await this.client.knowledgebase.getEmbeddingDimensions.query();
      getEmbeddingDimensionsFailureCount = 0;
      getEmbeddingDimensionsCached = {
        value: result,
        until: now + GET_EMBEDDING_DIMENSIONS_CACHE_MS
      };
      return result;
    } catch (err) {
      getEmbeddingDimensionsFailureCount += 1;
      const backoffMs = Math.min(
        GET_EMBEDDING_DIMENSIONS_INITIAL_BACKOFF_MS * Math.pow(2, getEmbeddingDimensionsFailureCount - 1),
        GET_EMBEDDING_DIMENSIONS_MAX_BACKOFF_MS
      );
      getEmbeddingDimensionsBackoffUntil = now + backoffMs;
      logger6.warn(
        `Cloud getEmbeddingDimensions failed, backing off for ${backoffMs}ms (failure #${getEmbeddingDimensionsFailureCount}):`,
        err?.message ?? err
      );
      return null;
    }
  }
  getEmbedderDimensions() {
    return this.embedder.dimensions;
  }
  async repairMissingEmbeddings(_workspaceId) {
    return { repaired: 0 };
  }
};

// src/library/util/llm_debug.ts
var TOOLS_DEBUG_ENABLED = typeof process !== "undefined" && (process.env?.DEBUG === "true" || process.env?.OWLBERT_DEBUG_TOOLS === "true");
var WIRE_DEBUG_ENABLED = TOOLS_DEBUG_ENABLED;
var LLMDebugLogger = class {
  static logLLMCall(_assistantName, _messages, _options, _response, _error) {
    void _assistantName;
    void _messages;
    void _options;
    void _response;
    void _error;
  }
  static logWireProviderRequest(_assistantName, _payload) {
    void _assistantName;
    void _payload;
  }
  static logStructuredToolRound(_assistantName, _entries, _continuationUserMessage) {
    void _assistantName;
    void _entries;
    void _continuationUserMessage;
  }
  static logModelToolCallTurn(_assistantName, _message) {
    void _assistantName;
    void _message;
  }
  static logLegacyToolProcessResult(_assistantName, _xmlToolResultsBlock) {
    void _assistantName;
    void _xmlToolResultsBlock;
  }
};

// src/library/util/split_thinking_from_chat_content.ts
function pushThinkingPart(parts, inner) {
  const t = inner.trim();
  if (t) parts.push(t);
}
function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var OPEN_ANY = /<\s*(redacted_thinking[\w-]*|redacted-thinking|thinking|think)\b[^>]*>/i;
function maybeDecodeThinkingEntities(s) {
  if (!/&lt;\s*redacted_thinking/i.test(s) && !/&lt;\s*thinking\b/i.test(s) && !/&lt;\s*redacted-thinking/i.test(s) && !/&lt;\s*think\b/i.test(s)) {
    return s;
  }
  return s.replace(/&amp;/gi, "&").replace(/&lt;/gi, "<").replace(/&gt;/gi, ">");
}
function closePatternForTagName(tagName) {
  return new RegExp("</\\s*" + escapeRegExp(tagName) + "\\s*>", "i");
}
function findEarliestOpenAny(s) {
  let best = null;
  const re = new RegExp(OPEN_ANY.source, "gi");
  for (const m of s.matchAll(re)) {
    const idx = m.index ?? 0;
    const tagName = m[1] ?? "";
    const openLen = m[0].length;
    if (!tagName) continue;
    if (!best || idx < best.index) {
      best = { index: idx, tagName, openLen };
    }
  }
  return best;
}
function stripNextReasoningBlock(s, thinkingParts) {
  const open = findEarliestOpenAny(s);
  if (!open) return { changed: false, out: s };
  const { index: start, tagName, openLen } = open;
  const innerStart = start + openLen;
  const tail = s.slice(innerStart);
  const closeRe = closePatternForTagName(tagName);
  const cm = closeRe.exec(tail);
  if (!cm || cm.index === void 0) {
    pushThinkingPart(thinkingParts, tail);
    return { changed: true, out: s.slice(0, start).trimEnd() };
  }
  const closeStart = innerStart + cm.index;
  pushThinkingPart(thinkingParts, s.slice(innerStart, closeStart));
  const out = s.slice(0, start) + s.slice(closeStart + cm[0].length);
  return { changed: true, out };
}
function splitThinkingFromChatContent(text) {
  if (!text) {
    return { primary: "", thinking: "" };
  }
  const thinkingParts = [];
  let primary = maybeDecodeThinkingEntities(text).replace(/\r\n/g, "\n");
  for (let i = 0; i < 200; i++) {
    const { changed, out } = stripNextReasoningBlock(primary, thinkingParts);
    primary = out;
    if (!changed) break;
  }
  return {
    primary: primary.replace(/\n{3,}/g, "\n\n").trimEnd(),
    thinking: thinkingParts.join("\n\n")
  };
}

// src/library/llm/stream_types.ts
async function streamToCallback(stream, handler) {
  for await (const event of stream) {
    if (event.type === "text") handler(event.delta);
  }
}
function streamResultFromCallback(streamFn) {
  const queue = [];
  let resolveWait = () => {
  };
  let waitPromise = new Promise((r) => {
    resolveWait = r;
  });
  let responseSettled = false;
  const responsePromise = streamFn((chunk) => {
    queue.push({ type: "text", delta: chunk });
    resolveWait();
  }).then((r) => {
    responseSettled = true;
    resolveWait();
    return r;
  });
  const stream = {
    [Symbol.asyncIterator]: async function* () {
      while (!responseSettled || queue.length > 0) {
        if (queue.length === 0) await waitPromise;
        while (queue.length > 0) yield queue.shift();
      }
      const res = await responsePromise;
      yield { type: "finish", reason: res.finishReason };
    }
  };
  return { stream, response: responsePromise };
}

// src/library/llm/llm_types.ts
var UserRole = "user";
var AssistantRole = "assistant";
var SystemRole = "system";
var DefaultLLMOptions = {
  max_tokens: -1,
  temperature: 0.9,
  top_p: 0.8,
  frequency_penalty: 0.7,
  presence_penalty: 0.7,
  stop: [],
  top_k: 30
};
var Message = class {
  id;
  content;
  role;
  /** Optional metadata (e.g. trackedContentSnapshots for user messages). Persist with the message for cross-run delta tracking. */
  metadata;
  constructor(content, id = "", metadata) {
    this.content = content;
    this.role = "";
    this.metadata = metadata;
    if (id != "") {
      this.id = id;
    } else {
      this.id = Date.now().toString();
    }
  }
};
var SystemMessage = class extends Message {
  constructor(content, id = "", metadata) {
    super(content, id, metadata);
    this.role = SystemRole;
  }
};
var AssistantMessage = class extends Message {
  toolCalls;
  /** Set when the model stopped due to max_tokens/length; used to show "Continue?" in the UI. */
  finishReason;
  constructor(content, id = "", toolCalls, finishReason) {
    super(content, id);
    this.role = AssistantRole;
    this.toolCalls = toolCalls;
    if (finishReason !== void 0) this.finishReason = finishReason;
  }
};
var UserMessage = class extends Message {
  /** When set, LLM adapters send this as multimodal content (e.g. image + text). Otherwise content (string) is used. */
  contentParts;
  constructor(content, id = "", metadata) {
    const displayText = typeof content === "string" ? content : content.filter((p) => p.type === "text").map((p) => p.text).join("\n");
    super(displayText, id, metadata);
    this.role = UserRole;
    if (Array.isArray(content)) this.contentParts = content;
  }
};
function getUserMessageText(msg) {
  return msg.contentParts ? msg.contentParts.filter((p) => p.type === "text").map((p) => p.text).join("\n") : msg.content;
}
var DebugMessage = class extends Message {
  constructor(content, id = "") {
    super(content, id);
    this.role = "debug";
  }
};
var ToolMessage = class extends Message {
  toolCallId;
  constructor(toolCallId, content, id = "") {
    super(content, id);
    this.role = "tool";
    this.toolCallId = toolCallId;
  }
};

// src/library/assistant/memory.ts
var Memory = class {
  memory;
  timestamp;
  constructor(memory, timestamp = /* @__PURE__ */ new Date()) {
    this.memory = memory;
    this.timestamp = timestamp;
  }
};

// src/library/assistant/status.ts
var logger7 = getLogger("AssistantStatusHub");
var StatusHub = class {
  callbacks = /* @__PURE__ */ new Map();
  register(callbackId, callback) {
    logger7.info(`Registering callback ${callbackId}`);
    this.callbacks.set(callbackId, callback);
  }
  unregister(callbackId) {
    this.callbacks.delete(callbackId);
  }
  notify(status) {
    logger7.info(`Notifying callbacks of status:`, status);
    status.timestamp = Date.now();
    Array.from(this.callbacks?.keys()).forEach((key) => {
      logger7.info(`Notifying callback ${key}`);
      const callback = this.callbacks.get(key);
      if (!callback) {
        logger7.warn(`Callback ${key} not found`);
        return;
      } else {
        callback(status);
      }
    });
  }
};
var AssistantStatusHub = new StatusHub();

// src/library/assistant/tracked_content.ts
function defaultFormatDelta(oldContent, currentContent, name) {
  if (currentContent === "" && oldContent === "") {
    return "";
  }
  if (oldContent === "") {
    return `Initial content for "${name}":
${currentContent}`;
  }
  if (currentContent === oldContent) {
    return "";
  }
  const delta = formatLineDelta(oldContent, currentContent);
  if (delta === "") {
    return "";
  }
  return `Changes to "${name}":
${delta}`;
}
function formatLineDelta(oldContent, currentContent) {
  const oldLines = oldContent.split(/\n/);
  const newLines = currentContent.split(/\n/);
  const oldSet = new Set(oldLines);
  const newSet = new Set(newLines);
  const removed = oldLines.filter((line) => !newSet.has(line));
  const added = newLines.filter((line) => !oldSet.has(line));
  const parts = [];
  if (removed.length > 0) {
    parts.push("--- Removed lines:\n" + removed.map((l) => `- ${l}`).join("\n"));
  }
  if (added.length > 0) {
    parts.push("--- Added lines:\n" + added.map((l) => `+ ${l}`).join("\n"));
  }
  return parts.join("\n\n");
}
function createTrackedContent(options) {
  const formatDelta = options.formatDelta ?? ((oldContent) => defaultFormatDelta(oldContent, options.getContent(), options.name));
  return {
    id: options.id,
    name: options.name,
    description: options.description,
    getContent: options.getContent,
    formatDelta
  };
}

// src/library/assistant/conversation.ts
var logger8 = getLogger("Conversation");
var TOOL_RESULTS_CONTINUATION = "[Tool results above. Continue with your response.]";
var TOOL_RESULTS_STRICT_CONTINUATION = "[Tool results above. Reply to the user in plain language now\u2014do not call any tools in this message, only send a text response.]";
var ToolLoopStoppedError = class extends Error {
  constructor() {
    super("Tool loop stopped");
    this.name = "ToolLoopStoppedError";
  }
};
var Conversation = class {
  constructor(_) {
    this._ = _;
    logger8.info(
      `Additional context provided? ${this._.additionalContext != null}`
    );
    if (this._.additionalContext && this._.additionalContext.length > 0) {
      logger8.info(
        `Will inject ${this._.additionalContext.length} context items into latest user message`
      );
    }
    this.thread = [
      new SystemMessage(this._.systemPrompt),
      ...this._.history || []
    ];
    this.startingThreadSize = this.thread.length;
  }
  _;
  thread = [];
  startingThreadSize;
  /**
   * Format additionalContext as a single string for inclusion in the current user message.
   * Used at send time so context can be omitted or updated (e.g. when context is removed) without mutating stored history.
   */
  formatAdditionalContextSection() {
    const ctxList = this._.additionalContext;
    if (!ctxList || ctxList.length === 0) return "";
    const contextSection = ctxList.map((ctx, idx) => {
      const ctxWithContent = ctx;
      if (ctxWithContent.content != null && ctxWithContent.content !== "") {
        const content = String(ctxWithContent.content);
        return dedent`
                    <context_block index="${String(idx + 1)}" name="${ctx.name}">
                        <description>${ctx.description || ctx.name}</description>
                        <content>
                        ${content.split("\n").map((line) => `    ${line}`).join("\n")}
                        </content>
                    </context_block>
                    `;
      }
      if (!ctx.records || ctx.records.length === 0) {
        logger8.warn(`Context ${ctx.name} has no records or content, skipping`);
        return "";
      }
      const records = ctx.records.map((rec, recIdx) => {
        const recordJson = JSON.stringify(rec, null, 2);
        return dedent`
                            <record index="${String(recIdx + 1)}">
                                <data>
                                ${recordJson.split("\n").map((line) => `    ${line}`).join("\n")}
                                </data>
                            </record>`;
      });
      return dedent`
                    <context_block index="${String(idx + 1)}" name="${ctx.name}">
                        <description>${ctx.description || "No description provided"}</description>
                        <record_count>${String(ctx.records.length)}</record_count>
                        <records>
                        ${records.join("\n\n")}
                        </records>
                    </context_block>
                    `;
    }).filter((section) => section !== "").join("\n\n");
    return dedent`
            <additional_context>
            <context_count>${String(ctxList.length)}</context_count>
            ${contextSection}
            </additional_context>`;
  }
  /** Build the messages array to send to the LLM: inject additionalContext into the latest user message for this request. */
  messagesWithContextInLatestUserMessage(messages) {
    const contextSection = this.formatAdditionalContextSection();
    if (contextSection === "") return messages;
    let lastUserIdx = -1;
    for (let i = messages.length - 1; i >= 0; i--) {
      if (messages[i].role === "user") {
        lastUserIdx = i;
        break;
      }
    }
    if (lastUserIdx === -1) return messages;
    const lastUser = messages[lastUserIdx];
    const userText = getUserMessageText(lastUser);
    const contextPrefix = `${contextSection}

`;
    let newLastUser;
    if (lastUser.contentParts && lastUser.contentParts.length > 0) {
      const firstPart = lastUser.contentParts[0];
      if (!firstPart) return messages;
      if (firstPart.type === "text") {
        newLastUser = new UserMessage(
          [{ type: "text", text: contextPrefix + firstPart.text }, ...lastUser.contentParts.slice(1)],
          lastUser.id,
          lastUser.metadata
        );
      } else {
        newLastUser = new UserMessage(
          [{ type: "text", text: contextPrefix }, ...lastUser.contentParts],
          lastUser.id,
          lastUser.metadata
        );
      }
    } else {
      newLastUser = new UserMessage(contextPrefix + userText, lastUser.id, lastUser.metadata);
    }
    return [
      ...messages.slice(0, lastUserIdx),
      newLastUser,
      ...messages.slice(lastUserIdx + 1)
    ];
  }
  async send(message) {
    const { onMessage, abortSignal, trackedContent } = this._;
    logger8.info(`Sending message to LLM`);
    if (abortSignal?.aborted) {
      return Promise.reject(new Error("Conversation was cancelled"));
    }
    let messageToAppend = message;
    if (trackedContent && trackedContent.length > 0) {
      const lastUserWithSnapshots = this.findLastUserMessageWithTrackedSnapshots();
      const blocks = [];
      const snapshots = {};
      for (const item of trackedContent) {
        const prev = lastUserWithSnapshots?.metadata?.trackedContentSnapshots?.[item.id] ?? "";
        const current = item.getContent();
        const formatDelta = item.formatDelta ?? ((old) => defaultFormatDelta(old, item.getContent(), item.name));
        const deltaText = formatDelta(prev);
        if (deltaText !== "") {
          blocks.push(
            `<tracked_context name="${item.name}" id="${item.id}">
${deltaText}
</tracked_context>`
          );
          snapshots[item.id] = current;
        }
      }
      if (blocks.length > 0) {
        const trackedBlock = blocks.join("\n\n");
        const userText = getUserMessageText(message);
        if (message.contentParts) {
          messageToAppend = new UserMessage(
            [{ type: "text", text: trackedBlock + "\n\n" }, ...message.contentParts],
            message.id,
            { trackedContentSnapshots: snapshots }
          );
        } else {
          messageToAppend = new UserMessage(trackedBlock + "\n\n" + userText, message.id, {
            trackedContentSnapshots: snapshots
          });
        }
      }
    }
    onMessage?.(messageToAppend);
    this.thread = [...this.thread, messageToAppend];
    const lastMsg = this.thread[this.thread.length - 1];
    const isStrictTextOnlyTurn = lastMsg?.role === "user" && getUserMessageText(lastMsg).trim() === TOOL_RESULTS_STRICT_CONTINUATION.trim();
    const llmOptions = {
      ...DefaultLLMOptions,
      ...this._.options || {},
      tools: isStrictTextOnlyTurn ? void 0 : this._.toolProcessor?.tools || void 0
    };
    if (isStrictTextOnlyTurn) {
      logger8.info("Text-only turn after stop-after tool (tools omitted for this message)");
    }
    return this.getLLMResponse(this.thread, llmOptions).then((llmResponse) => {
      if (abortSignal?.aborted) {
        throw new Error("Conversation was cancelled");
      }
      this.thread.push(llmResponse);
      const toolCallsSummary = llmResponse.toolCalls?.length ? llmResponse.toolCalls.map((tc) => ({ name: tc.name, arguments: tc.arguments })) : void 0;
      logger8.info("LLM response:", {
        content: llmResponse.content ?? "(empty)",
        toolCalls: toolCallsSummary
      });
      if (TOOLS_DEBUG_ENABLED && llmResponse.toolCalls?.length) {
        LLMDebugLogger.logModelToolCallTurn(this._.assistantName, llmResponse);
      }
      onMessage?.(llmResponse);
      const triggers = this.responseTriggers(llmResponse);
      if (triggers.length > 0) {
        return this.handleTriggers(llmResponse, triggers).then(
          (response) => {
            if (abortSignal?.aborted) {
              throw new Error("Conversation was cancelled");
            }
            return this.send(response);
          }
        );
      }
      return llmResponse;
    });
  }
  getLLMResponse(messages, options) {
    const { streamHandler, streamConsumer, llm, abortSignal } = this._;
    if (abortSignal?.aborted) {
      return Promise.reject(new Error("Conversation was cancelled"));
    }
    const messagesToSend = this.messagesWithContextInLatestUserMessage(messages);
    const llmOptionsWithSignal = {
      ...DefaultLLMOptions,
      ...options,
      signal: options?.signal || abortSignal,
      debugAssistantName: this._.assistantName
    };
    if (streamConsumer) {
      const hasStreamEvents = typeof llm.streamEvents === "function";
      const result = hasStreamEvents ? llm.streamEvents(messagesToSend, llmOptionsWithSignal) : streamResultFromCallback((handler) => llm.stream(messagesToSend, handler, llmOptionsWithSignal));
      streamConsumer(result.stream).catch((err) => {
        logger8.error("Stream consumer error", err);
      });
      return result.response;
    }
    if (streamHandler) {
      return llm.stream(messagesToSend, streamHandler, llmOptionsWithSignal);
    }
    return llm.chat(messagesToSend, llmOptionsWithSignal);
  }
  async handleStructuredToolCalls(response) {
    const { toolProcessor } = this._;
    if (!response.toolCalls || response.toolCalls.length === 0) {
      return null;
    }
    if (!toolProcessor) {
      logger8.warn(
        "Received structured tool calls but no tool processor available"
      );
      return null;
    }
    logger8.info(
      `Processing ${response.toolCalls.length} structured tool calls`
    );
    const toolDebugEntries = [];
    const toolResults = [];
    let shouldStopAfterThisRound = false;
    for (const toolCall of response.toolCalls) {
      const tool = toolProcessor.tools.find((t) => t.id === toolCall.name);
      if (!tool) {
        logger8.error(`Tool ${toolCall.name} not found`);
        const notFoundPayload = {
          success: false,
          error: `Tool ${toolCall.name} not available`
        };
        const notFoundContent = JSON.stringify(notFoundPayload);
        toolResults.push(new ToolMessage(toolCall.id, notFoundContent));
        if (TOOLS_DEBUG_ENABLED) {
          toolDebugEntries.push({
            toolCallId: toolCall.id,
            toolName: toolCall.name,
            arguments: toolCall.arguments,
            executionResult: { success: false, error: notFoundPayload.error },
            contentSentToLlm: notFoundContent,
            phase: "tool_not_found"
          });
        }
        continue;
      }
      try {
        logger8.info(
          `Executing tool ${tool.id} with parameters ${JSON.stringify(
            toolCall.arguments
          )}`
        );
        const result = await toolProcessor.executeTool(
          toolCall.name,
          toolCall.arguments
        );
        const inner = result.result;
        const success = typeof inner?.success === "boolean" ? inner.success : result.success;
        const message = inner?.message ?? result.error;
        const formattedResult = {
          success,
          ...message != null && message !== "" ? { message } : {},
          ...result.result != null ? { result: result.result } : {},
          ...result.error != null && result.error !== message ? { error: result.error } : {}
        };
        const contentSentToLlm = JSON.stringify(formattedResult, null, 2);
        if (TOOLS_DEBUG_ENABLED) {
          toolDebugEntries.push({
            toolCallId: toolCall.id,
            toolName: toolCall.name,
            arguments: toolCall.arguments,
            executionResult: {
              success: result.success,
              result: result.result,
              error: result.error
            },
            contentSentToLlm,
            phase: "executed"
          });
        }
        if (success && this._.stopAfterToolIds?.includes(toolCall.name)) {
          shouldStopAfterThisRound = true;
        }
        toolResults.push(
          new ToolMessage(
            toolCall.id,
            contentSentToLlm
          )
        );
      } catch (err) {
        logger8.error(`Error executing tool ${tool.id}: ${err}`);
        const errorMessage = err instanceof Error ? err.message : String(err);
        const errPayload = {
          success: false,
          error: `Error executing tool: ${errorMessage}`
        };
        const errContent = JSON.stringify(errPayload, null, 2);
        toolResults.push(new ToolMessage(toolCall.id, errContent));
        if (TOOLS_DEBUG_ENABLED) {
          toolDebugEntries.push({
            toolCallId: toolCall.id,
            toolName: toolCall.name,
            arguments: toolCall.arguments,
            executionResult: { success: false, error: errorMessage },
            contentSentToLlm: errContent,
            phase: "execution_error",
            executionError: errorMessage
          });
        }
      }
    }
    this.thread.push(...toolResults);
    if (this._.onToolMessage) {
      for (const toolResult of toolResults) {
        this._.onToolMessage(toolResult);
      }
    }
    const stableArgs = (args) => {
      const o = args ?? {};
      return JSON.stringify(
        Object.keys(o).sort().reduce((acc, k) => {
          acc[k] = o[k];
          return acc;
        }, {})
      );
    };
    const fingerprint = (msg) => msg.toolCalls?.slice().sort((a, b) => a.name.localeCompare(b.name)).map((tc) => `${tc.name}:${stableArgs(tc.arguments)}`).join("|") ?? "";
    const currentFp = fingerprint(response);
    const threadBeforeThisRound = this.thread.slice(0, this.thread.length - toolResults.length);
    const assistantWithToolCalls = threadBeforeThisRound.filter(
      (m) => m.role === "assistant" && !!m.toolCalls?.length
    );
    const lastTwo = assistantWithToolCalls.slice(-2);
    const prevFp = lastTwo.length >= 2 ? fingerprint(lastTwo[0]) : "";
    if (lastTwo.length >= 2 && currentFp && prevFp && currentFp === prevFp) {
      logger8.info(
        "Stopping conversation: identical tool call repeated (same tool + same input loop)",
        { currentFp, prevFp }
      );
      throw new ToolLoopStoppedError();
    }
    const continuation = shouldStopAfterThisRound ? TOOL_RESULTS_STRICT_CONTINUATION : TOOL_RESULTS_CONTINUATION;
    LLMDebugLogger.logStructuredToolRound(
      this._.assistantName,
      toolDebugEntries,
      continuation
    );
    return new UserMessage(continuation);
  }
  async handleTriggers(response, triggers) {
    logger8.info(`Handling triggers: ${triggers.join(", ")}`);
    if (triggers.includes("structured_tool_call" /* StructuredToolCall */)) {
      const toolResult = await this.handleStructuredToolCalls(response);
      if (toolResult !== null) {
        return toolResult;
      }
    }
    return this.generateResponse(response, triggers);
  }
  async generateResponse(response, triggers) {
    const { toolProcessor, memoryProcessor } = this._;
    let toolsPart = null;
    if (triggers.includes("tools_request" /* ToolsRequest */) && toolProcessor) {
      toolsPart = await toolProcessor.process(response.content);
    }
    const memoryPart = triggers.includes("memory_request" /* MemoryRequest */) && memoryProcessor ? memoryProcessor.extractMemories(response.content) : null;
    const helpPart = triggers.includes("tool_help_request" /* ToolHelpRequest */) && toolProcessor ? toolProcessor.processToolHelp(response.content) : null;
    const body = [toolsPart, memoryPart, helpPart].filter((p) => p != null && p !== "").join("\n\n");
    if (TOOLS_DEBUG_ENABLED && toolsPart) {
      LLMDebugLogger.logLegacyToolProcessResult(this._.assistantName, toolsPart);
    }
    return new UserMessage(body);
  }
  findLastUserMessageWithTrackedSnapshots() {
    for (let i = this.thread.length - 1; i >= 0; i--) {
      const msg = this.thread[i];
      if (msg?.role === "user") {
        const userMsg = msg;
        if (userMsg.metadata?.trackedContentSnapshots) {
          return userMsg;
        }
      }
    }
    return void 0;
  }
  responseTriggers(response) {
    const { content } = response;
    return [
      // Check for structured tool calls first
      response.toolCalls && response.toolCalls.length > 0 ? "structured_tool_call" /* StructuredToolCall */ : null,
      // Legacy XML-based tool handling
      contentLooksLikeEmbeddedToolsRequest(content) ? "tools_request" /* ToolsRequest */ : null,
      content.includes("<memory>") && this._.memoryProcessor ? "memory_request" /* MemoryRequest */ : null,
      content.includes("<tool_help>") ? "tool_help_request" /* ToolHelpRequest */ : null
    ].filter((reason) => reason !== null);
  }
};

// src/library/assistant/instructions.ts
var CoreInstructions = dedent`
<core_instructions>
You are an expert AI assistant. Your identity, tone, and behavior are defined in the <persona> and <further_instructions> sections below. You MUST adopt that identity and follow those instructions in every single response. Do not respond as a generic assistant—respond as the character or role specified.

XML-like tags structure data in this prompt (e.g. <rules></rules>, <tools></tools>). Use the information in <useful_info></useful_info> when relevant.

<rules>
* CRITICAL: Stay in character. Your <persona> and <further_instructions> define who you are and how you respond. Every message must reflect them.
* When the user asks your name or who you are, your name is the value in <your_name> in <useful_info>. Say that name and describe yourself according to your <persona>. Never say your name is "Assistant" or "AI assistant" unless that is literally in <your_name>.
* Use today's date for any date-related tasks.
* Complete every task you are given to the best of your ability.
* Answer only what was asked or complete only the task given—do not add unsolicited information or tasks.
* Honor response format requirements (word count, JSON structure, style, etc.).
* Use the context provided together with the instructions to generate your response.
* If examples are provided, follow their pattern.
* If <persona> or <further_instructions> are present, they override any generic assistant behavior. Follow them first.
</rules>
</core_instructions>
`;
var ToolsIntro = `
<how_to_use_tools>
<overview>
You can invoke tools by providing the tool ID and its parameters in JSON format between <tools> and </tools> tags.
</overview>

<invocation_format>
To invoke a tool, use the following format:

<tools>
[
    {
        "tool": "tool_id",
        "parameters": {
            "param1": "value1",
            "param2": "value2"
        }
    }
]
</tools>
</invocation_format>

<result_format>
After tool execution, you will receive results in the following format:

<tool_results>
[
    {
        "tool": "tool_id",
        "success": true,
        "result": {
            // Tool-specific result data matching the output_schema
        },
        "error": null
    }
]
</tool_results>
</result_format>

<rules>
<rule>Before using a tool, make sure you have read the complete tool instructions including input_schema and output_schema.</rule>
<rule>DO NOT make up parameters - only use parameters defined in the tool's input_schema.</rule>
<rule>MAKE SURE to put the JSON array between <tools> and </tools> tags or the tool will not be invoked.</rule>
<rule>If you do not receive a <tool_results> tag, the tool was not invoked correctly - check your format and try again.</rule>
<rule>Provide all required parameters as specified in the input_schema - missing required parameters will cause the tool to fail.</rule>
<rule>Do NOT include any parameters that are not in the tool's input_schema - they will be ignored or cause errors.</rule>
<rule>Do NOT put comments in the JSON - it must be valid JSON only.</rule>
<rule>If you decide to use a tool, ONLY include the JSON array for the tool(s) in your response; do not add commentary outside the tags.</rule>
<rule>DO NOT send an incomplete JSON object - ensure all required parameters are present and the JSON is complete and valid.</rule>
<rule>Parameter values must match the types specified in the input_schema (string, number, boolean, object, array, etc.).</rule>
<rule>EMERGENCY BRAKE: If a tool fails repeatedly (e.g. 3 or more times with similar errors), you MUST stop retrying. Do not continue attempting the same or similar tool calls. Instead, explain clearly what went wrong, what you tried, and ask the user for help. The user may need to fix something, grant permission, or provide guidance. Continuing to retry tool calls that keep failing is not helpful.</rule>
</rules>
</how_to_use_tools>
`;
var MemoryInstructions = `
<memory_instructions>
If you think something is noteworthy, I can store memories for you.
In any response, write down the memory inside a <memory></memory> tag.
I will store exactly what is between the tags.
The memories you have will be returned in between <memories></memories> tags during the conversation.
ALWAYS consider memories when you are coming up with your responses.
</memory_instructions>
`;

// src/library/assistant/prompt_builder.ts
var PromptBuilder = class {
  sections = [];
  addSection(title, content) {
    if (!content || Array.isArray(content) && content.length === 0) return;
    const body = Array.isArray(content) ? content.join("\n") : content;
    if (body.trim().length === 0) return;
    this.sections.push(dedent`
            ${title.toUpperCase()}
            
            ${body}
        `);
  }
  addBulletList(title, items) {
    if (!items || items.length === 0) return;
    const content = items.map((i) => `* ${i}`).join("\n");
    this.addSection(title, content);
  }
  addJsonSchema(title, schema) {
    if (!schema) return;
    this.addSection(title, JSON.stringify(schema, null, 2));
  }
  build() {
    return this.sections.join("\n\n");
  }
};
var JSON_RESPONSE_INSTRUCTIONS = [
  "OUTPUT FORMAT (NON-NEGOTIABLE): Your entire reply must be parseable as JSON and nothing else.",
  "- Do NOT wrap JSON in markdown code fences (no ```json blocks).",
  "- Do NOT write introductions, explanations, apologies, or any prose before or after the JSON.",
  "- Do NOT echo the task text or repeat instructions \u2014 only the JSON value.",
  "- Optional: you may wrap the JSON in <response></response> tags. If you do, there must be nothing outside those tags except optional whitespace, and the ONLY content inside the tags must be the raw JSON (no commentary mixed in).",
  "If your output is not valid JSON (or fails the schema below), you will be asked to fix it \u2014 so follow these rules exactly.",
  "",
  "STRING VALUES IN JSON:",
  "- Prefer a single line per string value; if you need a line break inside a string, escape it as \\n \u2014 do not break the JSON across physical lines inside a string.",
  '- Double quotes (") inside strings must be escaped as \\"',
  "- Use double quotes for all keys and string values \u2014 single-quoted strings are invalid JSON.",
  "",
  "EXAMPLE of CORRECT JSON with a string containing a newline:",
  '{ "message": "Line 1\\nLine 2" }',
  "",
  "EXAMPLE of INCORRECT output (DO NOT DO THIS \u2014 prose + fences):",
  "Here is the JSON:",
  "```json",
  '{ "a": 1 }',
  "```",
  "",
  "The JSON must conform to the response schema in the next section."
];

// src/library/util/struct_xml.ts
var StructToXMLLikeString = (context) => {
  if (Object.keys(context).length === 0) {
    return "";
  }
  const lines = Object.keys(context).map((key) => {
    const value = Object.entries(context).find(([k]) => k === key)?.[1];
    if (typeof value === "string") {
      if (value.length > 0) {
        return `<${key}>${value}</${key}>`;
      }
    } else if (Array.isArray(value)) {
      const children = value.map((v) => {
        if (typeof v === "string") {
          return `<item>${v}</item>`;
        } else {
          return `<${key}>${StructToXMLLikeString(v)}</${key}>`;
        }
      });
      return `<${key}>${children.join("\n")}</${key}>`;
    } else if (typeof value === "object") {
      return `<${key}>${StructToXMLLikeString(value)}</${key}>`;
    }
    return "";
  });
  return lines.join("\n");
};

// src/library/assistant/tool_processor.ts
var logger9 = getLogger("ToolProcessor");
var ToolExecution = class {
  constructor(tool, input, updateCallback, context) {
    this.tool = tool;
    this.input = input;
    this.updateCallback = updateCallback;
    this.context = context;
  }
  tool;
  input;
  updateCallback;
  context;
  invocationId = md5(Date.now().toString());
  async execute() {
    this.update("started", `Invoking tool ${this.tool.purpose}`, {
      input: JSON.stringify(this.input, null, 4)
    });
    try {
      const results = await this.tool.invoke(this.input, this.context);
      if (!results.success) {
        const errorMessage = results.error || "Tool execution failed";
        this.update("failed", `Tool ${this.tool.purpose} failed: ${errorMessage}`, {
          result: errorMessage
        });
        return results;
      }
      const resultString = results.result ? StructToXMLLikeString(results.result) : "Successfully executed tool with no results";
      this.update("completed", `Tool ${this.tool.purpose} completed`, {
        result: resultString,
        input: ""
      });
      return results;
    } catch (err) {
      this.update("failed", `Tool ${this.tool.purpose} failed`, {
        exception: err
      });
      throw new Error(`Error invoking tool ${this.tool.purpose}: ${err}`);
    }
  }
  update(state, message, data) {
    this.updateCallback({
      invocationId: this.invocationId,
      toolId: this.tool.id,
      state,
      message,
      data
    });
  }
};
var ToolProcessor = class {
  statusCallbacks = [];
  _tools;
  _context;
  constructor(tools, context) {
    this._tools = tools;
    this._context = context;
    this.addStatusCallback = this.addStatusCallback.bind(this);
    this.emitToolStatus = this.emitToolStatus.bind(this);
  }
  get tools() {
    return this._tools;
  }
  get context() {
    return this._context;
  }
  set context(context) {
    this._context = context;
  }
  addStatusCallback(callback) {
    this.statusCallbacks.push(callback);
  }
  /**
   * Single execution path for structured tool calls, XML-extracted tools, and MCP tools/call.
   * @param contextOverride - When set (e.g. per-request session from MCP), used instead of the processor's default context.
   */
  async executeTool(toolId, input, contextOverride) {
    const tool = this._tools.find((t) => t.id === toolId);
    if (!tool) {
      logger9.error(`Tool ${toolId} not found in tools map`);
      return {
        success: false,
        error: `Tool ${toolId} not available in this assistant`
      };
    }
    const ctx = contextOverride !== void 0 ? contextOverride : this._context;
    try {
      logger9.info(`Invoking tool ${tool.id} with parameters ${JSON.stringify(input)}`);
      const execution = new ToolExecution(tool, input, this.emitToolStatus, ctx);
      const results = await execution.execute();
      if (results === void 0) {
        return {
          success: false,
          error: "Tool execution returned no result"
        };
      }
      return results;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : String(err);
      logger9.error(`Error invoking tool ${tool.id}: ${errorMessage}`);
      return {
        success: false,
        error: errorMessage
      };
    }
  }
  async process(content) {
    let toolRequests;
    try {
      toolRequests = ExtractToolsRequests(content);
    } catch (err) {
      if (err instanceof ToolParseError) {
        logger9.warn("Embedded tools parse error", { message: err.message });
        return `I'm sorry, I saw a <tools> section but could not run tools from it. Check that you include valid JSON (an array of { "tool", "parameters" }) inside <tools>...</tools>. Details: ${err.message}`;
      }
      throw err;
    }
    if (toolRequests.length === 0) {
      return "I'm sorry, I couldn't find any tools in the message you just sent me.";
    }
    const toolResults = /* @__PURE__ */ new Map();
    for (const request of toolRequests) {
      const results = await this.executeTool(request.tool, request.parameters);
      if (!results.success) {
        toolResults.set(request.tool, {
          success: false,
          result: results.error || "ERROR",
          error: results.error || "Tool execution failed"
        });
      } else {
        toolResults.set(request.tool, {
          success: true,
          result: results.result !== void 0 ? JSON.stringify(results.result) : "Success",
          error: void 0
        });
      }
    }
    const toolResultsArray = Array.from(toolResults.entries()).map(([tool, result]) => {
      return {
        tool,
        success: result.success,
        result: result.result,
        error: result.error
      };
    });
    return [
      "<tool_results>",
      `<execution_count>${toolResults.size}</execution_count>`,
      "<results>",
      JSON.stringify(toolResultsArray, null, 2),
      "</results>",
      "</tool_results>"
    ].join("\n");
  }
  processToolHelp(content) {
    const toolIds = ExtractToolHelpRequests(content);
    const helpResults = toolIds.map((toolId, idx) => {
      const tool = this._tools.find((t) => t.id === toolId);
      if (!tool) {
        return [
          `  <help_result index="${idx + 1}">`,
          `    <tool_id>${toolId}</tool_id>`,
          `    <status>not_found</status>`,
          `    <error>I'm sorry, I couldn't find the tool you requested help with (${toolId}).</error>`,
          `  </help_result>`
        ].join("\n");
      }
      return [
        `  <help_result index="${idx + 1}">`,
        `    <tool_id>${tool.id}</tool_id>`,
        `    <status>found</status>`,
        `    <instructions>`,
        AssistantToolInstructions(tool).split("\n").map((line) => `      ${line}`).join("\n"),
        `    </instructions>`,
        `  </help_result>`
      ].join("\n");
    });
    return [
      "<tool_help_results>",
      `<request_count>${toolIds.length}</request_count>`,
      "<results>",
      ...helpResults,
      "</results>",
      "</tool_help_results>"
    ].join("\n");
  }
  emitToolStatus(update) {
    this.statusCallbacks.forEach((cb) => cb(update));
  }
};

// src/library/assistant/memory_processor.ts
var MemoryProcessor = class {
  constructor(storage) {
    this.storage = storage;
  }
  storage;
  shouldProcess(message) {
    return message.content.includes("<memory>");
  }
  extractMemories(message) {
    const memoryRegex = /.*?<memory>(.*?)<\/memory>.*/gs;
    const matches = message.matchAll(memoryRegex);
    let storeCount = 0;
    for (const match of matches) {
      const memory = match[1];
      if (!memory) {
        continue;
      }
      this.storage.store(new Memory(memory));
      storeCount++;
    }
    return `I've extracted and stored ${storeCount} memories from the message you just sent me.`;
  }
  fetchMemories() {
    const memories = this.storage.all();
    if (memories.length === 0) {
      return "";
    }
    return [
      "<memories>",
      ...memories.map((memory) => `<memory>${memory}</memory>`),
      "</memories>"
    ].join("\n");
  }
};

// src/library/assistant/task.ts
import { ZodError as ZodError2 } from "zod";
var Task = class {
  contextSchema;
  taskLLMOptions = {
    max_tokens: -1,
    temperature: 0.9,
    top_p: 0.9,
    top_k: 50,
    frequency_penalty: 0,
    presence_penalty: 0,
    stop: []
  };
  validateContext(params) {
    const schema = this.contextSchema;
    if (schema && typeof schema.parse === "function") {
      try {
        schema.parse(params.context);
      } catch (err) {
        if (err instanceof ZodError2) {
          const parts = err.flatten().fieldErrors;
          const errorStr = Object.entries(parts).map(([key, messages]) => `${key}: ${Array.isArray(messages) ? messages.join(", ") : messages}`).join("; ");
          throw new Error(`Invalid task context: ${errorStr}`);
        }
        throw err instanceof Error ? err : new Error(String(err));
      }
    }
  }
  get llmOptions() {
    return this.taskLLMOptions;
  }
  get definition() {
    return {
      name: this.name,
      description: this.description,
      instructions: this.instructions.join("\n"),
      examples: this.examples
    };
  }
  prompt(params) {
    return dedent`
    <prompt>
    ${this.taskSpecifics(params)}
    </prompt>`;
  }
  fullInstructions() {
    const builder = new PromptBuilder();
    builder.addSection("Task Instructions", [
      "Make absolutely sure to follow these instructions as closely as you possibly can.",
      "",
      ...this.instructions
    ]);
    const additional = this.additionalInstructions?.();
    if (additional && additional.length > 0) {
      builder.addBulletList("Additional Instructions", additional);
    }
    return builder.build();
  }
};

// src/library/assistant/tasks/json_task.ts
import {
  objectPropsSchemaToJsonSchema,
  validateObject
} from "@owlbert/schema-types";
function isZodResponseSchema(schema) {
  return typeof schema === "object" && schema !== null && "safeParse" in schema && typeof schema.safeParse === "function";
}
function responseSchemaToJsonSchema(schema) {
  if (isZodResponseSchema(schema)) {
    return zodToJsonSchema(schema);
  }
  return objectPropsSchemaToJsonSchema(schema);
}
var logger10 = getLogger("JSONTask");
var DEFAULT_JSON_TASK_EXTRA_RETRIES = 2;
function appendJsonParseFailureFeedback(basePrompt, rawModelOutput, error) {
  const msg = error instanceof Error ? error.message : String(error);
  const maxLen = 4e3;
  const preview = rawModelOutput.length > maxLen ? `${rawModelOutput.slice(0, maxLen)}
\u2026 [truncated; total length ${String(rawModelOutput.length)} characters]` : rawModelOutput;
  return dedent`
        ${basePrompt}

        =============================================================================
        VALIDATION FAILED — YOUR PREVIOUS OUTPUT WAS NOT ACCEPTED
        =============================================================================
        The system could not use your last message: it was not valid JSON, or it did not match the required response schema.

        Error (verbatim): ${msg}

        YOU MUST RESPOND AGAIN. Requirements:
        - Output ONLY valid JSON matching the response schema in the instructions above.
        - No markdown code fences (\`\`\`json). No preamble or postscript. No explanatory sentences.
        - If you use <response></response>, only JSON may appear inside the tags.

        Your rejected output (correct this in your next reply):
        ${preview}
    `;
}
async function runPromptWithJsonRetries(basePrompt, executeOnce, parseResponse, maxExtraRetries = DEFAULT_JSON_TASK_EXTRA_RETRIES) {
  let prompt = basePrompt;
  let lastRaw = "";
  const maxAttempts = 1 + Math.max(0, maxExtraRetries);
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    lastRaw = await executeOnce(prompt);
    try {
      return parseResponse(lastRaw);
    } catch (e) {
      logger10.warn("JSON task parse failed", {
        attempt: attempt + 1,
        maxAttempts,
        message: e instanceof Error ? e.message : String(e)
      });
      if (attempt === maxAttempts - 1) {
        throw e;
      }
      prompt = appendJsonParseFailureFeedback(basePrompt, lastRaw, e);
    }
  }
  throw new Error("runPromptWithJsonRetries: exhausted attempts without success");
}
var JSONTask = class extends Task {
  contentType = "json";
  additionalInstructions = () => {
    if (!this.responseSchema) return [];
    const builder = new PromptBuilder();
    builder.addSection("Response Instructions", JSON_RESPONSE_INSTRUCTIONS);
    builder.addJsonSchema(
      "Response Schema",
      responseSchemaToJsonSchema(this.responseSchema)
    );
    return [builder.build()];
  };
  parseResponse(response) {
    if (!response) {
      logger10.info("Empty response");
      throw new Error("Empty response");
    }
    let jsonText = response.trim();
    if (jsonText.includes("<response>") && jsonText.includes("</response>")) {
      const start = jsonText.indexOf("<response>") + "<response>".length;
      const end = jsonText.indexOf("</response>");
      jsonText = jsonText.substring(start, end).trim();
    }
    if (!jsonText || jsonText === "") {
      logger10.info("Empty JSON response");
      throw new Error("Empty JSON response");
    }
    try {
      const extractedJSON = extractJSON(jsonText);
      const jsonToParse = extractedJSON?.json || jsonText;
      let result;
      try {
        result = JSON.parse(jsonToParse);
      } catch (parseError) {
        logger10.warn(
          "Initial parse failed, attempting JSON repair",
          {
            error: parseError instanceof Error ? parseError.message : "Unknown error",
            preview: jsonToParse.substring(0, 200)
          }
        );
        try {
          const repairedText = repairJSON(jsonToParse);
          result = JSON.parse(repairedText);
          logger10.info("Successfully parsed JSON after repair");
        } catch (repairError) {
          let repairPreview = jsonToParse.substring(0, 300);
          try {
            repairPreview = repairJSON(jsonToParse).substring(0, 300);
          } catch {
          }
          logger10.error(
            "Failed to parse JSON after repair attempts:",
            {
              originalPreview: response.substring(0, 300),
              cleanedPreview: jsonText.substring(0, 300),
              repairPreview,
              parseError: parseError instanceof Error ? parseError.message : "Unknown",
              repairError: repairError instanceof Error ? repairError.message : "Unknown"
            }
          );
          throw new Error(
            `Invalid JSON response after repair: ${repairError instanceof Error ? repairError.message : "Parse error"}`
          );
        }
      }
      if (this.responseSchema) {
        if (isZodResponseSchema(this.responseSchema)) {
          const parsed = this.responseSchema.safeParse(result);
          if (!parsed.success) {
            logger10.info(
              "JSON response failed schema validation:",
              parsed.error.flatten()
            );
            throw new Error(
              `JSON response failed schema validation: ${JSON.stringify(parsed.error.flatten())}`
            );
          }
          return parsed.data;
        }
        const vr = validateObject(
          this.responseSchema,
          result
        );
        if (!vr.success) {
          logger10.info(
            "JSON response failed schema validation:",
            vr.errors
          );
          throw new Error(
            `JSON response failed schema validation: ${JSON.stringify(vr.errors)}`
          );
        }
        return result;
      }
      logger10.info("Successfully parsed JSON response");
      return result;
    } catch (e) {
      if (e instanceof Error && e.message.includes("schema validation")) {
        throw e;
      }
      const responseLength = response?.length ?? 0;
      logger10.error("Error parsing JSON response:", {
        error: e instanceof Error ? e.message : "Unknown error",
        responseLength,
        responsePreview: response.substring(0, 200)
      });
      throw new Error(
        `Invalid JSON response (length: ${responseLength} chars): ${e instanceof Error ? e.message : "Unknown error"}`
      );
    }
  }
};
var defineJsonTask = (config) => {
  return class extends JSONTask {
    name = config.name;
    description = config.description;
    instructions = config.instructions;
    responseSchema = config.responseSchema;
    contextSchema = config.contextSchema;
    taskSpecifics = config.taskSpecifics || (() => "");
    examples = config.examples || [];
  };
};

// src/library/assistant/tasks/text_task.ts
var TextTask = class extends Task {
  contentType = "text";
  additionalInstructions = () => [];
  parseResponse(response) {
    return response;
  }
};
var defineTextTask = (config) => {
  return class extends TextTask {
    name = config.name;
    description = config.description;
    instructions = config.instructions;
    contextSchema = config.contextSchema;
    taskSpecifics = config.taskSpecifics || (() => "");
    examples = config.examples || [];
  };
};

// src/library/mcp/client.ts
var logger11 = getLogger("McpClient");
function isJsonRpcError(res) {
  return res && "error" in res && res.error != null;
}
async function initialize(transport) {
  const res = await transport.request("initialize", {
    protocolVersion: "2024-11-05",
    capabilities: {},
    clientInfo: { name: "owlbert-mcp-client", version: "0.1.0" }
  });
  if (isJsonRpcError(res)) {
    throw new Error(`MCP initialize failed: ${res.error.message}`);
  }
  if (transport.notify) {
    await transport.notify("notifications/initialized", {});
  }
  return res.result ?? {};
}
async function listTools(transport) {
  const res = await transport.request("tools/list", {});
  if (isJsonRpcError(res)) {
    throw new Error(`MCP tools/list failed: ${res.error.message}`);
  }
  const result = res.result;
  const tools = result?.tools ?? [];
  logger11.info("MCP tools/list", { count: tools.length, names: tools.map((t) => t.name) });
  return tools;
}
async function callTool(transport, name, args) {
  const res = await transport.request("tools/call", { name, arguments: args });
  if (isJsonRpcError(res)) {
    return {
      content: [{ type: "text", text: res.error.message }],
      isError: true
    };
  }
  const result = res.result;
  const content = result?.content ?? [];
  const structuredContent = result?.structuredContent != null && typeof result.structuredContent === "object" ? result.structuredContent : void 0;
  const isError = result?.isError ?? false;
  return { content, structuredContent, isError };
}
async function initializeAndListTools(transport) {
  await initialize(transport);
  return listTools(transport);
}

// src/library/mcp/mcp_tools.ts
var logger12 = getLogger("McpTools");
var mcpParamsSchema = z2.record(z2.string(), z2.unknown());
function createMcpAssistantTool(transport, def, idPrefix) {
  const id = idPrefix ? `${idPrefix}_${def.name}` : def.name;
  const purpose = def.description ?? def.name;
  const description = def.description ?? `MCP tool: ${def.name}`;
  const ToolClass = class extends AssistantTool {
    id = id;
    purpose = purpose;
    description = description;
    parameters = mcpParamsSchema;
    results = ToolResultsSchema(z2.string().optional());
    async exec(input, _context) {
      const { content, isError, structuredContent } = await callTool(transport, def.name, input);
      const text = content?.filter((c) => c.type === "text" && c.text != null).map((c) => c.text).join("\n").trim();
      if (structuredContent != null && typeof structuredContent === "object") {
        const sc = structuredContent;
        const scOk = sc.success === true && !isError;
        if (!scOk) {
          const err = typeof sc.error === "string" ? sc.error : text ?? "MCP tool returned an error";
          return { success: false, error: err, result: text };
        }
        if (sc.result !== void 0) {
          const r = sc.result;
          return {
            success: true,
            result: typeof r === "string" ? r : JSON.stringify(r)
          };
        }
        return { success: true, result: text ?? void 0 };
      }
      if (isError) {
        return { success: false, error: text ?? "MCP tool returned an error", result: text };
      }
      return { success: true, result: text ?? void 0 };
    }
  };
  return new ToolClass();
}
async function loadToolsFromMcpTransport(transport, serverName) {
  const definitions = await initializeAndListTools(transport);
  const tools = definitions.map((def) => createMcpAssistantTool(transport, def, serverName));
  logger12.info("Loaded MCP tools", { serverName, count: tools.length, ids: tools.map((t) => t.id) });
  return tools;
}
async function loadToolsFromMcpTransports(configs, context) {
  const allTools = [];
  for (const { name, transport } of configs) {
    try {
      const tools = await loadToolsFromMcpTransport(transport, name);
      allTools.push(...tools);
    } catch (err) {
      const serverLabel = name ?? "(unnamed MCP server)";
      const detail = err instanceof Error ? err.message : String(err);
      logger12.warn(`MCP server unavailable; skipping tools from "${serverLabel}": ${detail}`);
      AssistantStatusHub.notify({
        title: "MCP unavailable",
        kind: "warning",
        state: "completed",
        message: `Skipped MCP server "${serverLabel}": ${detail}`.slice(0, 500),
        assistantName: context?.assistantName ?? "Assistant"
      });
      const close = transport.close;
      if (typeof close === "function") {
        try {
          close.call(transport);
        } catch {
        }
      }
    }
  }
  return allTools;
}

// src/library/assistant_agent.ts
var Assistant = class {
  llm;
  name;
  instructions;
  description;
  tools;
  mcpTransports;
  chatHistoryStore;
  memoryStore;
  stopAfterToolIds;
  // maxThreadDepth removed - conversations can now be unlimited depth
  // Use cancellation to interrupt long-running conversations instead
  mcpToolsPromise;
  constructor(options) {
    const { llm, name, ...assistant } = options;
    this.name = name;
    this.llm = llm;
    Object.assign(this, assistant);
  }
  /**
   * When `mcpAllowIds` is set (staged tool policy), only MCP tools whose `id` is in the set are merged.
   * Static `this.tools` are unchanged — callers should already restrict static tools when staging.
   */
  async getEffectiveTools(mcpAllowIds) {
    const staticTools = this.tools ?? [];
    if (!this.mcpTransports || this.mcpTransports.length === 0) {
      return staticTools;
    }
    if (!this.mcpToolsPromise) {
      this.mcpToolsPromise = loadToolsFromMcpTransports(this.mcpTransports, {
        assistantName: this.name
      });
    }
    const mcpTools = await this.mcpToolsPromise;
    if (mcpAllowIds) {
      return [...staticTools, ...mcpTools.filter((t) => mcpAllowIds.has(t.id))];
    }
    return [...staticTools, ...mcpTools];
  }
  /** Staged policy: MCP tools are allowlisted by session-attached tool ids passed on toolContext. */
  mcpAllowIdsFromToolContext(tc) {
    if (!tc || tc.stagedToolPolicy !== true) return void 0;
    const ids = tc.stagedMcpAllowIds;
    if (!Array.isArray(ids)) return /* @__PURE__ */ new Set();
    return new Set(ids.map((x) => String(x)));
  }
  get toolIds() {
    return this.tools?.map((tool) => tool.id) || [];
  }
  get toolInstructions() {
    if (!this.tools || this.tools.length === 0) {
      return "";
    }
    return [
      "<tool_instructions>",
      `<tool_count>${this.tools.length}</tool_count>`,
      this.tools.map(
        (tool) => AssistantToolInstructions(tool)
      ).join("\n\n"),
      "</tool_instructions>"
    ].join("\n");
  }
  get availableTools() {
    if (this.tools && this.tools.length > 0) {
      const availableTools = this.tools.map((t, idx) => {
        return `      <tool index="${String(idx + 1)}" id="${t.id}">
        <purpose>${t.purpose}</purpose>
        <description>${t.getDescription?.() ?? t.description}</description>
      </tool>`;
      }).join("\n");
      return dedent`
      <available_tools>
      <tool_count>${String(this.tools.length)}</tool_count>
      <instruction>Here are the tools you can use, along with a brief description of each.</instruction>
      <help_instruction>For help on a specific tool, respond with: <tool_help tool_id="tool_id"/></help_instruction>
      
      ${availableTools}
      </available_tools>`;
    } else {
      return "";
    }
  }
  get usefulInformation() {
    const now = /* @__PURE__ */ new Date();
    return [
      "<useful_info>",
      `<todays_date>${now.toDateString()}</todays_date>`,
      `<current_time>${now.toLocaleTimeString()}</current_time>`,
      `<your_name>${this.name}</your_name>`,
      "<name_usage>When asked your name or identity, respond with the name in <your_name> and stay in character per your persona.</name_usage>",
      `<name_answer>If the user asks "What is your name?" or "Who are you?", you MUST reply with: "My name is ${this.name}." Do not say "Assistant".</name_answer>`,
      "</useful_info>"
    ].join("\n");
  }
  /**
   * Checks if the LLM supports structured tools (like Anthropic or OpenAI)
   * These LLMs handle tools natively, so we don't need the XML-based tool instructions
   */
  supportsStructuredTools() {
    return this.llm.supportsStructuredTools();
  }
  get systemPrompt() {
    const hasTools = this.tools && this.toolIds.length > 0;
    const shouldIncludeToolsIntro = hasTools && !this.supportsStructuredTools();
    const hasPersona = this.description && this.description.length > 0;
    const hasInstructions = this.instructions && this.instructions.length > 0;
    const identityBlock = [
      hasPersona ? `<persona>${this.description}</persona>` : "",
      hasInstructions ? `<further_instructions>
${this.instructions}
</further_instructions>` : ""
    ].filter(Boolean).join("\n\n");
    const systemPromptComponents = [
      CoreInstructions,
      this.usefulInformation,
      identityBlock,
      shouldIncludeToolsIntro ? ToolsIntro : "",
      hasTools && !this.supportsStructuredTools() ? this.toolInstructions : "",
      this.memoryStore ? MemoryInstructions : "",
      this.memories.length > 0 ? `<memories>
<memory_count>${this.memories.length}</memory_count>
${this.memories.map((memory, idx) => `<memory index="${idx + 1}">${memory.memory}</memory>`).join("\n")}
</memories>` : "",
      // Reinforce at end: models often weight the last part of the system prompt
      hasPersona || hasInstructions ? "<reminder>Respond in every message according to your <persona> and <further_instructions> above. Stay in character.</reminder>" : ""
    ];
    const systemPrompt = systemPromptComponents.filter((line) => line !== "").join("\n\n");
    return new SystemMessage(systemPrompt, "assistant_system_prompt");
  }
  history(chat_session_id, max_length) {
    return this.chatHistoryStore?.history(chat_session_id, max_length) || [];
  }
  async stream(chat_session_id, prompt, streamHandler, options, additionalContext) {
    const { memoryStore, llm } = this;
    const mcpAllow = this.mcpAllowIdsFromToolContext(
      options?.toolContext
    );
    const tools = await this.getEffectiveTools(mcpAllow);
    const toolProcessor = new ToolProcessor(tools, options?.toolContext);
    const memoryProcessor = memoryStore ? new MemoryProcessor(memoryStore) : void 0;
    const onMessage = this.chatHistoryStore ? (message) => this.chatHistoryStore?.store(chat_session_id, message) : void 0;
    const onToolMessage = this.chatHistoryStore ? (message) => this.chatHistoryStore?.store(chat_session_id, message) : void 0;
    const streamSystemPrompt = this.systemPrompt.content + (options?.additionalSystemPrompt ? "\n\n" + options.additionalSystemPrompt : "");
    const conversation = new Conversation({
      sessionId: chat_session_id,
      assistantName: this.name,
      systemPrompt: streamSystemPrompt,
      toolProcessor,
      memoryProcessor,
      llm,
      // maxDepth removed: unlimited depth, use cancellation to interrupt
      abortSignal: options?.signal,
      // Pass abort signal to conversation
      streamHandler,
      history: this.history(chat_session_id),
      options,
      onMessage,
      onToolMessage,
      additionalContext,
      stopAfterToolIds: this.stopAfterToolIds
    });
    return conversation.send(prompt).catch((err) => {
      if (err instanceof ToolLoopStoppedError) {
        return new AssistantMessage("I'll pause here\u2014reply again when you're ready.");
      }
      throw err;
    });
  }
  async chat(chat_session_id, prompt, options) {
    const { memoryStore, llm } = this;
    const mcpAllow = this.mcpAllowIdsFromToolContext(
      options?.toolContext
    );
    const tools = await this.getEffectiveTools(mcpAllow);
    const toolProcessor = new ToolProcessor(tools, options?.toolContext);
    const memoryProcessor = memoryStore ? new MemoryProcessor(memoryStore) : void 0;
    const onMessage = this.chatHistoryStore ? (message) => this.chatHistoryStore?.store(chat_session_id, message) : void 0;
    const onToolMessage = this.chatHistoryStore ? (message) => this.chatHistoryStore?.store(chat_session_id, message) : void 0;
    const systemPrompt = this.systemPrompt.content + (options?.additionalSystemPrompt ? "\n\n" + options.additionalSystemPrompt : "");
    const conversation = new Conversation({
      sessionId: chat_session_id,
      assistantName: this.name,
      systemPrompt,
      toolProcessor,
      memoryProcessor,
      llm,
      // maxDepth removed - unlimited depth, use cancellation to interrupt
      abortSignal: options?.llmOptions?.signal,
      // Pass abort signal to conversation
      history: this.history(chat_session_id),
      options: options?.llmOptions,
      onMessage,
      onToolMessage,
      additionalContext: options?.additionalContext,
      stopAfterToolIds: this.stopAfterToolIds,
      trackedContent: options?.trackedContent
    });
    return conversation.send(prompt).catch((err) => {
      if (err instanceof ToolLoopStoppedError) {
        return new AssistantMessage("I'll pause here\u2014reply again when you're ready.");
      }
      throw err;
    });
  }
  async generate(prompt, llmOptions, extraSystemPrompt, additionalContext, trackedContent) {
    this.updateStatus({
      title: "Processing",
      kind: "chat",
      message: `Generating response....`,
      assistantName: this.name,
      state: "started"
    });
    const { llm } = this;
    const tools = await this.getEffectiveTools();
    const toolProcessor = new ToolProcessor(tools);
    const conversation = new Conversation({
      assistantName: this.name,
      systemPrompt: this.systemPrompt.content + (extraSystemPrompt ? "\n\n" + extraSystemPrompt : ""),
      toolProcessor,
      llm,
      // maxDepth removed - unlimited depth, use cancellation to interrupt
      options: llmOptions,
      additionalContext,
      stopAfterToolIds: this.stopAfterToolIds,
      trackedContent
    });
    const result = await conversation.send(new UserMessage(prompt));
    this.updateStatus({
      title: "Completed",
      kind: "generate",
      message: `Generation complete....`,
      assistantName: this.name,
      state: "completed"
    });
    return result;
  }
  emitToolStatus(invocationId, toolName, state, message, attributes) {
    AssistantStatusHub.notify({
      title: "Tool Invocation",
      kind: "tool",
      message,
      assistantName: this.name,
      state,
      attributes: {
        invocationId,
        model: this.llm.toString(),
        toolName,
        ...attributes
      }
    });
  }
  updateStatus(status) {
    if (status.id === void 0 || !status.id || status.id === "") {
      status.id = md5(
        status.message + status.assistantName + status.kind + status.state
      );
    }
    AssistantStatusHub.notify(status);
  }
  get memories() {
    return this.memoryStore?.all() || [];
  }
  clearHistory(chat_session_id) {
    this.chatHistoryStore?.clear(chat_session_id);
  }
  deleteMessages(chat_session_id, messageIds) {
    messageIds.forEach(
      (id) => this.chatHistoryStore?.remove(chat_session_id, id)
    );
  }
  sessions() {
    return this.chatHistoryStore?.session_ids() || [];
  }
  tokenCount(chat_session_id) {
    return this.chatHistoryStore?.tokenCount(chat_session_id) || -1;
  }
};

// src/library/mcp/workspace_mcp_config.ts
function parseWorkspaceMcpStdioArgsJson(s) {
  const t = s.trim();
  if (!t) return [];
  try {
    const v = JSON.parse(t);
    if (!Array.isArray(v)) return [];
    return v.filter((x) => typeof x === "string");
  } catch {
    return [];
  }
}
function parseWorkspaceMcpSseHeadersJson(s) {
  const t = s.trim();
  if (!t) return {};
  try {
    const v = JSON.parse(t);
    if (v == null || typeof v !== "object" || Array.isArray(v)) return null;
    const out = {};
    for (const [k, val] of Object.entries(v)) {
      if (typeof val === "string") out[k] = val;
    }
    return out;
  } catch {
    return null;
  }
}
function normalizeWorkspaceMcpSlugInput(name, slug) {
  const s = slug.trim() || name.trim() || "mcp-server";
  return s.toLowerCase().replace(/\s+/g, "-");
}
function isLikelyHttpSseUrl(url) {
  const u = url.trim();
  return u.startsWith("http://") || u.startsWith("https://");
}
function buildWorkspaceMcpStdioConfig(command, argsJson) {
  const cmd = command.trim();
  if (!cmd) return { ok: false, message: "Command is required for stdio MCP servers." };
  const args = parseWorkspaceMcpStdioArgsJson(argsJson);
  return { ok: true, config: { command: cmd, args } };
}
function buildWorkspaceMcpSseConfig(url, headersJson) {
  const u = url.trim();
  if (!u || !isLikelyHttpSseUrl(u)) {
    return { ok: false, message: "SSE MCP requires a non-empty http:// or https:// URL." };
  }
  const headers = parseWorkspaceMcpSseHeadersJson(headersJson);
  if (headers === null) {
    return { ok: false, message: "Headers must be a JSON object with string values." };
  }
  const config = { url: u };
  if (Object.keys(headers).length > 0) config.headers = headers;
  return { ok: true, config };
}

// src/index.ts
var import_workspace_modules = __toESM(require_dist(), 1);

// src/library/hosted/owlbert_managed_policy.ts
function isOwlbertHostedSessionFromBackend(backend) {
  if (!backend) return false;
  return !!(backend.token || backend.refresh_token || backend.username && backend.password);
}
function isOwlbertManagedForLlmsPolicy(input) {
  if (!input.hostedSessionActive) return false;
  if (!input.proDesktopBuild) return true;
  if (!input.isProMode) return true;
  return input.owlbertManagedLlms === true;
}
function isOwlbertManagedForKnowledgePolicy(input) {
  if (!input.hostedSessionActive) return false;
  if (!input.proDesktopBuild) return true;
  if (!input.isProMode) return true;
  return input.owlbertManagedKnowledge !== false;
}

// src/library/hosted/owlbert_cloud_catalog.ts
var OWLBERT_CLOUD_KB_EMBEDDING_DIMENSIONS = 512;
function filterOwlbertCloudLlmCatalogForHostedWeb(models) {
  return models.filter((m) => m.provider !== "custom");
}

// src/library/catalog/hosted_library_tree.ts
function humanizeCatalogTypeLabel(key) {
  if (/\[\d+\]/.test(key)) return "";
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
function buildHostedCatalogLibraryTree(input) {
  const { typeNames, entitiesByType } = input;
  const uniqueTypeNames = [...new Set(typeNames)];
  if (uniqueTypeNames.length === 0) return [];
  const byPrefix = /* @__PURE__ */ new Map();
  for (const typeName of uniqueTypeNames) {
    const slash = typeName.indexOf("/");
    const prefix = slash >= 0 ? typeName.slice(0, slash) : "";
    const key = prefix || "\0";
    if (!byPrefix.has(key)) byPrefix.set(key, []);
    byPrefix.get(key).push(typeName);
  }
  const treeNodes = [];
  function makeTypeNode(typeName) {
    const results = [...entitiesByType[typeName] ?? []];
    const entityNodes = [...results].sort((a, b) => (a.name || "").localeCompare(b.name || "")).map((entity) => ({
      label: entity.name || "Unknown",
      value: `${typeName}:${entity.key}`,
      nodeProps: {
        entry: {
          id: entity.key,
          name: entity.name || "Unknown",
          entity,
          type: typeName
        }
      }
    }));
    const displayName = typeName.includes("/") ? humanizeCatalogTypeLabel(typeName.split("/").pop() ?? typeName) : humanizeCatalogTypeLabel(typeName);
    return {
      label: displayName,
      value: typeName,
      children: entityNodes,
      nodeProps: { isSection: true, typeName },
      entityCount: entityNodes.length
    };
  }
  const flatTypes = byPrefix.get("\0");
  if (flatTypes) {
    for (const typeName of flatTypes.sort(
      (a, b) => humanizeCatalogTypeLabel(a).localeCompare(humanizeCatalogTypeLabel(b), void 0, { sensitivity: "base" })
    )) {
      treeNodes.push(makeTypeNode(typeName));
    }
  }
  const prefixes = [...byPrefix.keys()].filter((k) => k !== "\0").sort(
    (a, b) => humanizeCatalogTypeLabel(a).localeCompare(humanizeCatalogTypeLabel(b), void 0, { sensitivity: "base" })
  );
  for (const prefix of prefixes) {
    const typesInGroup = byPrefix.get(prefix).slice().sort((a, b) => {
      const suffixA = a.includes("/") ? a.split("/").pop() : a;
      const suffixB = b.includes("/") ? b.split("/").pop() : b;
      return humanizeCatalogTypeLabel(suffixA).localeCompare(humanizeCatalogTypeLabel(suffixB), void 0, {
        sensitivity: "base"
      });
    });
    const typeNodes = typesInGroup.map((typeName) => makeTypeNode(typeName));
    const totalEntities = typeNodes.reduce((n, t) => n + (t.entityCount ?? 0), 0);
    treeNodes.push({
      label: humanizeCatalogTypeLabel(prefix),
      value: `group:${prefix}`,
      children: typeNodes,
      nodeProps: { isSection: true },
      entityCount: totalEntities
    });
  }
  treeNodes.sort(
    (a, b) => String(a.label ?? "").localeCompare(String(b.label ?? ""), void 0, { sensitivity: "base" })
  );
  return treeNodes;
}
var export_CORE_MODULE_NAME = import_workspace_modules.CORE_MODULE_NAME;
var export_DEFAULT_ENABLED_MODULE_NAMES = import_workspace_modules.DEFAULT_ENABLED_MODULE_NAMES;
var export_KNOWN_PLUGIN_FALLBACKS = import_workspace_modules.KNOWN_PLUGIN_FALLBACKS;
var export_KNOWN_PLUGIN_LICENSE_FEATURE_IDS = import_workspace_modules.KNOWN_PLUGIN_LICENSE_FEATURE_IDS;
var export_OWLBERT_PRO_FEATURE_ID = import_workspace_modules.OWLBERT_PRO_FEATURE_ID;
var export_PLUGIN_FEATURES_ALL = import_workspace_modules.PLUGIN_FEATURES_ALL;
var export_PLUGIN_FEATURE_ID_PREFIX = import_workspace_modules.PLUGIN_FEATURE_ID_PREFIX;
var export_PLUGIN_FEATURE_WILDCARD = import_workspace_modules.PLUGIN_FEATURE_WILDCARD;
var export_coerceEnabledModulesForHosted = import_workspace_modules.coerceEnabledModulesForHosted;
var export_derivePluginLicenseFeatureIdForModule = import_workspace_modules.derivePluginLicenseFeatureIdForModule;
var export_ensureCoreInList = import_workspace_modules.ensureCoreInList;
var export_isOwlbertProFromLicenseFeatureIds = import_workspace_modules.isOwlbertProFromLicenseFeatureIds;
var export_licenseFeatureListIncludes = import_workspace_modules.licenseFeatureListIncludes;
var export_listHostedWebModuleSettingsRows = import_workspace_modules.listHostedWebModuleSettingsRows;
var export_listHostedWebNavModules = import_workspace_modules.listHostedWebNavModules;
var export_normalizeLicenseFeatureIdForLookup = import_workspace_modules.normalizeLicenseFeatureIdForLookup;
var export_normalizeOwlbertModuleKey = import_workspace_modules.normalizeOwlbertModuleKey;
var export_normalizePluginLicenseSlugFromModuleName = import_workspace_modules.normalizePluginLicenseSlugFromModuleName;
var export_resolveCanonicalHostedWebModuleName = import_workspace_modules.resolveCanonicalHostedWebModuleName;
var export_validateEnabledModulesForHosted = import_workspace_modules.validateEnabledModulesForHosted;
export {
  Assistant,
  AssistantMessage,
  AssistantRole,
  AssistantStatusHub,
  AssistantTool,
  AssistantToolInstructions,
  export_CORE_MODULE_NAME as CORE_MODULE_NAME,
  ContextCatalog,
  Conversation,
  CoreInstructions,
  export_DEFAULT_ENABLED_MODULE_NAMES as DEFAULT_ENABLED_MODULE_NAMES,
  DEFAULT_USER_DOCUMENT_KB_CHUNK_SIZE,
  DebugMessage,
  DefaultLLMOptions,
  Document,
  ExtractToolHelpRequests,
  ExtractToolsRequests,
  GetLibraryDocumentTool,
  HOSTED_ASSISTANTS_PROCEDURE_KEYS,
  HOSTED_CHAT_MESSAGES_PROCEDURE_KEYS,
  HOSTED_CHAT_SESSION_METADATA_PROCEDURE_KEYS,
  HOSTED_LIBRARY_PROCEDURE_KEYS,
  HOSTED_PAGE_STATE_PROCEDURE_KEYS,
  HOSTED_SESSION_ATTACHMENTS_PROCEDURE_KEYS,
  HOSTED_USER_DOCUMENTS_PROCEDURE_KEYS,
  HOSTED_WORKSPACES_PROCEDURE_KEYS,
  JSONTask,
  JSON_RESPONSE_INSTRUCTIONS,
  KB_SEARCH_MIN_SIMILARITY_THRESHOLD,
  KB_SEARCH_MIN_SIMILARITY_WITHOUT_CONTENT_MATCH,
  KB_SEARCH_STRICT_SHORT_QUERY_MAX_WORDS,
  export_KNOWN_PLUGIN_FALLBACKS as KNOWN_PLUGIN_FALLBACKS,
  export_KNOWN_PLUGIN_LICENSE_FEATURE_IDS as KNOWN_PLUGIN_LICENSE_FEATURE_IDS,
  Knowledgebase,
  KnowledgebaseTool,
  LLMDebugLogger,
  Memory,
  MemoryInstructions,
  MemoryProcessor,
  Message,
  OWLBERT_CLOUD_KB_EMBEDDING_DIMENSIONS,
  export_OWLBERT_PRO_FEATURE_ID as OWLBERT_PRO_FEATURE_ID,
  export_PLUGIN_FEATURES_ALL as PLUGIN_FEATURES_ALL,
  export_PLUGIN_FEATURE_ID_PREFIX as PLUGIN_FEATURE_ID_PREFIX,
  export_PLUGIN_FEATURE_WILDCARD as PLUGIN_FEATURE_WILDCARD,
  PromptBuilder,
  REMOTE_KNOWLEDGEBASE_PROCEDURE_KEYS,
  SEARCH_KNOWLEDGEBASE_NONSTAGED_HINT,
  STAGED_CHAT_TOOL_POLICY_PROMPT,
  StatusHub,
  SystemMessage,
  SystemRole,
  TOOLS_DEBUG_ENABLED,
  TOOL_RESULTS_CONTINUATION,
  TOOL_RESULTS_STRICT_CONTINUATION,
  Task,
  TextTask,
  ToolLoopStoppedError,
  ToolMessage,
  ToolParseError,
  ToolProcessor,
  ToolResultsSchema,
  ToolsIntro,
  TrpcAutoEmbeddingEmbedder,
  TrpcCloudVectorDb,
  USER_DOCUMENT_KB_SOURCE_PREFIX,
  UserMessage,
  UserRole,
  WIRE_DEBUG_ENABLED,
  appendJsonParseFailureFeedback,
  buildHostedCatalogLibraryTree,
  buildHostedTrpcUrl,
  buildUserDocumentKbParentDocument,
  buildWorkspaceMcpSseConfig,
  buildWorkspaceMcpStdioConfig,
  callTool,
  export_coerceEnabledModulesForHosted as coerceEnabledModulesForHosted,
  contentLooksLikeEmbeddedToolsRequest,
  contextCatalog,
  createBrowserHostedSessionClient,
  createHostedOwlbertClient,
  createLocalStorageOwlbertSessionStore,
  createTrackedContent,
  defaultFormatDelta,
  defineJsonTask,
  defineTextTask,
  defineTool,
  export_derivePluginLicenseFeatureIdForModule as derivePluginLicenseFeatureIdForModule,
  export_ensureCoreInList as ensureCoreInList,
  filterOwlbertCloudLlmCatalogForHostedWeb,
  finalizeKnowledgebaseSearchResults,
  getKnowledgebaseContentMatchScore,
  getKnowledgebaseDocumentKey,
  getKnowledgebaseNameMatchScore,
  getKnowledgebaseNameMatchScoreDiscoveryOnly,
  getSearchKnowledgebasePolicyAppendIfNeeded,
  getUserMessageText,
  hostedAssistantsCreate,
  hostedAssistantsDelete,
  hostedAssistantsList,
  hostedAssistantsUpdate,
  hostedChatMessagesAppendToMessage,
  hostedChatMessagesCopyHistory,
  hostedChatMessagesDeleteForSession,
  hostedChatMessagesDeleteMessage,
  hostedChatMessagesGetForSession,
  hostedChatMessagesUpsertMessage,
  hostedChatSessionMetadataDeleteSession,
  hostedChatSessionMetadataGetForWorkspace,
  hostedChatSessionMetadataRemoveBookmark,
  hostedChatSessionMetadataSetBookmark,
  hostedChatSessionMetadataSetDisplayName,
  hostedChatSessionMetadataUpsertMetadata,
  hostedLibraryGet,
  hostedLibrarySet,
  hostedPageStateGet,
  hostedPageStateGetAll,
  hostedPageStateRemove,
  hostedPageStateSet,
  hostedSessionAttachmentsAdd,
  hostedSessionAttachmentsGetContent,
  hostedSessionAttachmentsList,
  hostedSessionAttachmentsMarkIncluded,
  hostedSessionAttachmentsRemove,
  hostedUserDocumentsAdd,
  hostedUserDocumentsAddSourceLocation,
  hostedUserDocumentsDelete,
  hostedUserDocumentsGet,
  hostedUserDocumentsList,
  hostedUserDocumentsUpdate,
  hostedWorkspacesCreate,
  hostedWorkspacesDelete,
  hostedWorkspacesList,
  hostedWorkspacesUpdate,
  humanizeCatalogTypeLabel,
  indexUserDocumentParentIntoKnowledgebase,
  initialize,
  initializeAndListTools,
  isHostedUserDocumentTrashed,
  isLikelyHttpSseUrl,
  isNonIndexableUserDocumentContent,
  isOwlbertHostedSessionFromBackend,
  isOwlbertManagedForKnowledgePolicy,
  isOwlbertManagedForLlmsPolicy,
  export_isOwlbertProFromLicenseFeatureIds as isOwlbertProFromLicenseFeatureIds,
  export_licenseFeatureListIncludes as licenseFeatureListIncludes,
  export_listHostedWebModuleSettingsRows as listHostedWebModuleSettingsRows,
  export_listHostedWebNavModules as listHostedWebNavModules,
  listTools,
  loadToolsFromMcpTransport,
  loadToolsFromMcpTransports,
  logger3 as logger,
  logicalDocumentIdForKbFetch,
  normalizeHostedBackendBaseUrl,
  export_normalizeLicenseFeatureIdForLookup as normalizeLicenseFeatureIdForLookup,
  export_normalizeOwlbertModuleKey as normalizeOwlbertModuleKey,
  export_normalizePluginLicenseSlugFromModuleName as normalizePluginLicenseSlugFromModuleName,
  normalizeWorkspaceMcpSlugInput,
  parseWorkspaceMcpSseHeadersJson,
  parseWorkspaceMcpStdioArgsJson,
  partitionHostedUserDocumentsByTrash,
  remoteKnowledgebaseDeleteBySourceId,
  remoteKnowledgebaseDeleteBySourceIdAndDocumentId,
  remoteKnowledgebaseDeleteByWorkspaceId,
  remoteKnowledgebaseGetAllDocuments,
  remoteKnowledgebaseGetEmbeddingDimensions,
  remoteKnowledgebaseInsert,
  remoteKnowledgebaseSearch,
  remoteKnowledgebaseTableExists,
  export_resolveCanonicalHostedWebModuleName as resolveCanonicalHostedWebModuleName,
  resolveUserDocumentKbSourceId,
  runPromptWithJsonRetries,
  scoreKnowledgebaseChunk,
  shouldUseStagedToolPolicyForConfig,
  sortHostedUserDocumentsByDeletedAtDesc,
  splitThinkingFromChatContent,
  streamResultFromCallback,
  streamToCallback,
  export_validateEnabledModulesForHosted as validateEnabledModulesForHosted,
  vectorDistanceToSimilarity,
  z2 as z
};
//# sourceMappingURL=index.js.map